(function() {
  'use strict';
  var S = window.YomikoeSettings || {};
  var CS = window.YomikoeCartStrings || {};

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString(S.locale || 'es', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function escHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function fetchCart() { return fetch('/cart.js').then(function(r) { return r.json(); }); }

  /* ===== Store fabrication hours (from shop metafield via window.YomikoeStoreHours.fabRaw) ===== */
  var YK_DOW = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function ykStoreNow() {
    var cfg = window.YomikoeStoreHours;
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: (cfg && cfg.timezone) || 'America/Argentina/Buenos_Aires' })); }
    catch (e) { return new Date(); }
  }
  function ykFabMap() {
    var cfg = window.YomikoeStoreHours; if (!cfg) return {};
    if (cfg._fabMap) return cfg._fabMap;
    var m = {};
    String(cfg.fabRaw || '').split(',').forEach(function(p) {
      var i = p.indexOf(':'); if (i < 0) return;
      var d = p.slice(0, i).trim().toLowerCase(), t = p.slice(i + 1).trim();
      if (d) m[d] = t;
    });
    cfg._fabMap = m; return m;
  }
  // Returns fabrication cutoff (minutes since midnight) for a day-of-week (0=Sun..6=Sat), or null if no fabrication.
  function ykFabCutoff(dow) {
    var v = ykFabMap()[YK_DOW[dow]];
    if (!v) return null;
    var p = String(v).split(':'), h = parseInt(p[0], 10);
    if (isNaN(h)) return null;
    return h * 60 + (parseInt(p[1], 10) || 0);
  }

  /* ==================
     PAGE LOADING ANIMATIONS
     ================== */
  var pageLoadingOverlay = document.getElementById('page-loading-overlay');
  var mainContentWrapper = document.querySelector('.main-content-wrapper');
  var header = document.querySelector('.site-header');
  
  // Initialize Intersection Observer for scroll animations
  var observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };
  
  var fadeUpObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeUpObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  // Observe all fade-up elements
  function initFadeUpAnimations() {
    var fadeUpElements = document.querySelectorAll('.fade-up, .fade-up-stagger');
    fadeUpElements.forEach(function(el) {
      fadeUpObserver.observe(el);
    });
  }
  
  // Page load animation sequence - NO DELAYS
  function animatePageLoad() {
    // Hide loading overlay immediately
    if (pageLoadingOverlay) {
      pageLoadingOverlay.classList.add('is-hidden');
    }
    
    // Animate header immediately
    if (header) {
      header.classList.add('header-animate', 'is-visible');
    }
    
    // Animate main content immediately
    if (mainContentWrapper) {
      mainContentWrapper.classList.add('is-visible');
    }
    
    // Initialize scroll animations immediately
    initFadeUpAnimations();
  }
  
  // Handle navigation loading state
  function initNavigationLoading() {
    // Listen for clicks on internal links
    document.addEventListener('click', function(e) {
      // If another handler already cancelled the default action (e.g., cart drawer),
      // the user is NOT actually navigating. Don't show the loading overlay.
      if (e.defaultPrevented) return;

      var link = e.target.closest('a[href]');
      if (!link) return;
      
      var href = link.getAttribute('href');
      
      // Skip external links, anchors, and opens in new tab
      if (!href || href.indexOf('http') === 0 || href.indexOf('#') === 0 || link.target === '_blank') return;
      
      // Skip if it's the same page
      if (href === window.location.pathname || href === window.location.href) return;
      
      // Show loading overlay
      if (pageLoadingOverlay) {
        pageLoadingOverlay.classList.remove('is-hidden');
      }
      
      // Reset main content
      if (mainContentWrapper) {
        mainContentWrapper.classList.remove('is-visible');
      }
    });
    
    // Handle bfcache restoration (back/forward button)
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        // Page was restored from bfcache - reset animation state
        if (pageLoadingOverlay) {
          pageLoadingOverlay.classList.add('is-hidden');
        }
        if (mainContentWrapper) {
          mainContentWrapper.classList.add('is-visible');
        }
        if (header) {
          header.classList.add('is-visible');
        }
        // Re-initialize fade-up animations
        initFadeUpAnimations();
      }
    });
  }
  
  // Run on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    animatePageLoad();
    initNavigationLoading();
  });

  /* ==================
     CART NOTIFICATION
     ================== */
  var notifEl = document.getElementById('cart-notification');
  var notifTimer;
  function showCartNotification(title) {
    // Desktop: open floating cart drawer instead of toast. Skip if on cart page.
    // Pass autoClose: true because this is triggered after adding a product
    // (the drawer acts as a confirmation notification, not a full cart view).
    if (typeof window.openCartDrawer === 'function' && window.matchMedia('(min-width: 768px)').matches && !document.getElementById('cart-items-container')) {
      window.openCartDrawer({ autoClose: true });
      return;
    }
    if (!notifEl) return;
    var t = document.getElementById('cart-notification-title');
    if (t) t.textContent = title;
    notifEl.classList.add('is-visible'); notifEl.setAttribute('aria-hidden', 'false');
    clearTimeout(notifTimer); notifTimer = setTimeout(hideCartNotification, 3500);
  }
  function hideCartNotification() {
    if (!notifEl) return;
    notifEl.classList.remove('is-visible'); notifEl.setAttribute('aria-hidden', 'true');
  }
  function initNotificationClose() {
    if (!notifEl) return;
    var c = notifEl.querySelector('.cart-notification__close');
    if (c) c.addEventListener('click', hideCartNotification);
  }

  /* ==================
     CART BADGE + TOTALS
     ================== */
  function updateCartBadge(cart) {
    document.querySelectorAll('.cart-count').forEach(function(b) {
      b.textContent = cart.item_count; b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }
  function getCartComparePrices() {
    var el = document.getElementById('cart-compare-prices');
    try { return el ? JSON.parse(el.textContent) : {}; } catch(e) { return {}; }
  }

  function calcCartSavings(cart) {
    var comparePrices = getCartComparePrices();
    var originalTotal = 0;
    var totalSavings = 0;
    cart.items.forEach(function(item) {
      var compareAt = comparePrices[item.variant_id] || 0;
      if (compareAt > item.price) {
        var lineCompare = compareAt * item.quantity;
        originalTotal += lineCompare;
        totalSavings += lineCompare - item.final_line_price;
      } else {
        originalTotal += item.final_line_price;
      }
    });
    return { originalTotal: originalTotal, totalSavings: totalSavings };
  }

  function refreshCartTotals(cart) {
    var disc = S.transferDiscount || 10;
    var da = Math.round(cart.total_price * disc / 100);
    var tt = cart.total_price - da;
    var savings = calcCartSavings(cart);
    document.querySelectorAll('[data-cart-original]').forEach(function(el) { el.textContent = formatMoney(savings.originalTotal); });
    document.querySelectorAll('[data-cart-original-row]').forEach(function(el) { el.style.display = savings.totalSavings > 0 ? '' : 'none'; });
    document.querySelectorAll('[data-cart-savings]').forEach(function(el) { el.textContent = '-' + formatMoney(savings.totalSavings); });
    document.querySelectorAll('[data-cart-savings-row]').forEach(function(el) { el.style.display = savings.totalSavings > 0 ? '' : 'none'; });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function(el) { el.textContent = formatMoney(cart.total_price); });
    document.querySelectorAll('[data-cart-discount]').forEach(function(el) { el.textContent = '-' + formatMoney(da); });
    document.querySelectorAll('[data-cart-transfer-total]').forEach(function(el) { el.textContent = formatMoney(tt); });
    document.querySelectorAll('[data-cart-total]').forEach(function(el) { el.textContent = formatMoney(cart.total_price); });
    document.querySelectorAll('[data-cart-transfer-savings]').forEach(function(el) { el.textContent = (window.YomikoeCartStrings.youSave || 'Ahorrás') + ' ' + formatMoney(da) + ' extra'; });
    updateCartBadge(cart);

    // Re-evaluate "Entrega Hoy" after cart changes so the 48hs notice clears/shows correctly
    if (window.YomikoeEntregaHoyFlags && cart.items) {
      window.YomikoeCartAllEntregaHoy = cart.items.length > 0 && cart.items.every(function(it) {
        return window.YomikoeEntregaHoyFlags[it.product_id] === true;
      });
      if (typeof window.YomikoeRefreshDelivery === 'function') window.YomikoeRefreshDelivery();
    }
  }

  /* ==================
     FULL CART REFRESH
     ================== */
  function fullCartRefresh() {
    return fetchCart().then(function(cart) {
      if (cart.item_count === 0) { location.reload(); return; }
      reRenderCartItems(cart);
      refreshCartTotals(cart);
    });
  }

  /* ==================
     CART DRAWER (desktop)
     ================== */
  var CART_DRAWER_BREAKPOINT = 768;
  var drawerOverlay, drawerBody, drawerCount, drawerSubtotal, drawerOriginalRow, drawerOriginal, drawerSavingsRow, drawerSavings, drawerPanel;
  var _drawerQtyTimer = null;
  var _drawerAutoCloseTimer = null;

  function isDesktopForDrawer() {
    return window.matchMedia('(min-width: ' + CART_DRAWER_BREAKPOINT + 'px)').matches;
  }

  function getDrawerEls() {
    drawerOverlay = drawerOverlay || document.getElementById('cart-drawer-overlay');
    drawerPanel = drawerPanel || document.getElementById('cart-drawer');
    drawerBody = drawerBody || document.querySelector('[data-drawer-body]');
    drawerCount = drawerCount || document.querySelector('[data-drawer-count]');
    drawerSubtotal = drawerSubtotal || document.querySelector('[data-drawer-subtotal]');
    drawerOriginalRow = drawerOriginalRow || document.querySelector('[data-drawer-original-row]');
    drawerOriginal = drawerOriginal || document.querySelector('[data-drawer-original]');
    drawerSavingsRow = drawerSavingsRow || document.querySelector('[data-drawer-savings-row]');
    drawerSavings = drawerSavings || document.querySelector('[data-drawer-savings]');
    return drawerOverlay;
  }

  function clearDrawerAutoClose() {
    if (_drawerAutoCloseTimer) {
      clearTimeout(_drawerAutoCloseTimer);
      _drawerAutoCloseTimer = null;
    }
    if (drawerOverlay) drawerOverlay.classList.remove('is-autoclosing');
  }

  function scheduleDrawerAutoClose() {
    clearDrawerAutoClose();
    if (!S.cartDrawerAutoclose) return;
    var secs = parseInt(S.cartDrawerAutocloseSeconds, 10);
    if (isNaN(secs) || secs <= 0) return;
    if (drawerOverlay) drawerOverlay.classList.add('is-autoclosing');
    // CSS custom prop so the progress bar matches the configured duration
    if (drawerPanel) drawerPanel.style.setProperty('--drawer-autoclose-duration', secs + 's');
    _drawerAutoCloseTimer = setTimeout(function() {
      _drawerAutoCloseTimer = null;
      if (drawerOverlay) drawerOverlay.classList.remove('is-autoclosing');
      closeCartDrawer();
    }, secs * 1000);
  }

  function drawerImgUrl(item) {
    // Try featured_image.url (modern /cart.js shape), fall back to item.image string
    var u = '';
    if (item.featured_image) {
      if (typeof item.featured_image === 'string') u = item.featured_image;
      else if (item.featured_image.url) u = item.featured_image.url;
    }
    if (!u && item.image) u = (typeof item.image === 'string') ? item.image : '';
    if (!u) return '';
    // Insert _140x size if Shopify CDN URL without existing size suffix
    try {
      if (/cdn\.shopify\.com/.test(u) && !/_\d+x\d*\./.test(u)) {
        return u.replace(/(\.[a-zA-Z]+)(\?|$)/, '_140x$1$2');
      }
    } catch (e) {}
    return u;
  }

  function renderCartDrawer(cart) {
    if (!getDrawerEls()) return;
    try {
      if (drawerCount) {
        drawerCount.textContent = cart.item_count;
        drawerCount.style.display = cart.item_count > 0 ? '' : 'none';
      }

      var summaryEl = document.getElementById('cart-drawer-summary');
      var footerEl = document.getElementById('cart-drawer-footer');

      if (!cart.items || cart.item_count === 0) {
        drawerBody.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" opacity=".35"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            '<p>' + (S.cartEmpty || 'Tu carrito est\u00e1 vac\u00edo') + '</p>' +
            '<button type="button" class="btn btn--secondary" onclick="closeCartDrawer();" style="margin-top:1rem;">' + (S.cartEmptyCta || 'Seguir comprando') + '</button>' +
          '</div>';
        if (summaryEl) summaryEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (summaryEl) summaryEl.style.display = '';
      if (footerEl) footerEl.style.display = '';

      var comparePrices = getCartComparePrices();
      var html = '';
      cart.items.forEach(function(item, idx) {
        var line = idx + 1;
        var imgSrc = drawerImgUrl(item);
        var compareAt = comparePrices[item.variant_id] || 0;
        var hasSavings = compareAt && compareAt > item.price;
        var title = item.product_title || item.title || '';
        var url = item.url || '#';

        var priceHtml;
        if (hasSavings) {
          var saved = (compareAt - item.price) * item.quantity;
          priceHtml =
            '<div class="cart-drawer__item-price">' +
              '<span class="cart-drawer__item-compare">' + formatMoney(compareAt) + '</span>' +
              '<span class="cart-drawer__item-unit">' + formatMoney(item.price) + '</span>' +
            '</div>' +
            '<span class="cart-drawer__item-savings">' + (S.cartYouSave || 'Ahorras') + ' ' + formatMoney(saved) + '</span>';
        } else {
          priceHtml = '<div class="cart-drawer__item-price"><span class="cart-drawer__item-unit">' + formatMoney(item.price) + '</span></div>';
        }

        var lineTotal = item.quantity > 1 ? '<span class="cart-drawer__item-total">' + formatMoney(item.final_line_price) + '</span>' : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cart-drawer__item-variant">' + escHtml(item.variant_title) + '</span>' : '';

        html +=
          '<article class="cart-drawer__item" data-drawer-line="' + line + '">' +
            '<a class="cart-drawer__item-media" href="' + url + '">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-drawer__item-info">' +
              '<a class="cart-drawer__item-title" href="' + url + '">' + escHtml(title) + '</a>' +
              variant +
              priceHtml +
              '<div class="cart-drawer__item-controls">' +
                '<div class="qty-wrap cart-drawer__qty">' +
                  '<button type="button" class="qty-btn" data-drawer-qty-action="decrease">\u2212</button>' +
                  '<input type="number" value="' + item.quantity + '" min="0" class="qty-input" data-drawer-qty-input>' +
                  '<button type="button" class="qty-btn" data-drawer-qty-action="increase">+</button>' +
                '</div>' +
                '<button type="button" class="cart-drawer__item-remove" data-drawer-remove aria-label="' + (S.cartRemove || 'Eliminar') + '">' +
                  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>' +
                '</button>' +
              '</div>' +
              lineTotal +
            '</div>' +
          '</article>';
      });
      drawerBody.innerHTML = html;

      // Summary - use display:none to bypass [hidden] override by our flex rule
      var savings = calcCartSavings(cart);
      var showSavings = savings.totalSavings > 0;
      if (drawerOriginalRow) drawerOriginalRow.style.display = showSavings ? 'flex' : 'none';
      if (drawerOriginal) drawerOriginal.textContent = formatMoney(savings.originalTotal);
      if (drawerSavingsRow) drawerSavingsRow.style.display = showSavings ? 'flex' : 'none';
      if (drawerSavings) drawerSavings.textContent = '-' + formatMoney(savings.totalSavings);
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    } catch (err) {
      if (window.console && console.error) console.error('[cart-drawer] render failed', err);
    }
  }

  function openCartDrawer(opts) {
    if (!getDrawerEls()) return;
    opts = opts || {};
    // Safety net: make sure the full-page navigation loading overlay is hidden,
    // in case another click handler triggered it before we could stop it.
    var plo = document.getElementById('page-loading-overlay');
    if (plo) plo.classList.add('is-hidden');
    var mcw = document.getElementById('MainContent');
    if (mcw && !mcw.classList.contains('is-visible')) mcw.classList.add('is-visible');
    // Show panel immediately with a skeleton so user sees the opening animation
    drawerOverlay.classList.add('is-visible');
    drawerOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawerOverlay.classList.add('is-updating');
    clearDrawerAutoClose();
    fetchCart()
      .then(function(cart) {
        renderCartDrawer(cart);
        drawerOverlay.classList.remove('is-updating');
        // Only start auto-close timer if caller requested it AND cart isn't empty
        if (opts.autoClose && cart.item_count > 0) scheduleDrawerAutoClose();
      })
      .catch(function(err) {
        drawerOverlay.classList.remove('is-updating');
        if (window.console && console.error) console.error('[cart-drawer] fetch failed', err);
        if (drawerBody) {
          drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>No pudimos cargar tu carrito. Volv\u00e9 a intentar.</p></div>';
        }
      });
  }

  function closeCartDrawer() {
    if (!getDrawerEls()) return;
    clearDrawerAutoClose();
    drawerOverlay.classList.remove('is-visible');
    drawerOverlay.classList.remove('is-updating');
    drawerOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  // expose for inline handlers
  window.closeCartDrawer = closeCartDrawer;

  function updateDrawerLine(line, qty) {
    if (!getDrawerEls()) return;
    // User is interacting with items; always cancel any pending auto-close.
    clearDrawerAutoClose();
    drawerOverlay.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
      drawerOverlay.classList.remove('is-updating');
      // If on cart page, also refresh that
      if (document.getElementById('cart-items-container')) {
        if (cart.item_count === 0) { location.reload(); return; }
        reRenderCartItems(cart);
        refreshCartTotals(cart);
      }
    })
    .catch(function(err) {
      drawerOverlay.classList.remove('is-updating');
      if (window.console && console.error) console.error('[cart-drawer] update failed', err);
    });
  }

  function initCartDrawer() {
    if (!getDrawerEls()) return;

    // Open: cart icon click on desktop (skip if already on cart page).
    // Register in CAPTURE phase so it runs before other bubble-phase click handlers
    // (like initNavigationLoading) that might show a page-loading overlay.
    document.addEventListener('click', function(e) {
      var icon = e.target.closest('.header-icon--cart');
      if (!icon) return;
      if (!isDesktopForDrawer()) return; // mobile falls through to /cart
      if (document.getElementById('cart-items-container')) return; // on cart page already
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
    }, true);

    // Close: overlay click (but not on drawer panel itself)
    drawerOverlay.addEventListener('click', function(e) {
      if (e.target === drawerOverlay) closeCartDrawer();
    });

    // Close: close button
    var closeBtn = document.getElementById('cart-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

    // Close: ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawerOverlay.classList.contains('is-visible')) closeCartDrawer();
    });

    // Cancel auto-close timer as soon as the user hovers/focuses the panel.
    if (drawerPanel) {
      drawerPanel.addEventListener('mouseenter', clearDrawerAutoClose);
      drawerPanel.addEventListener('focusin', clearDrawerAutoClose);
      drawerPanel.addEventListener('touchstart', clearDrawerAutoClose, { passive: true });
    }

    // Qty buttons (scoped to drawer). Stop propagation so other global
    // click handlers (like initQuantityButtons) don't also fire a synthetic
    // "change" event that would trigger a duplicate cart/change.js request.
    drawerOverlay.addEventListener('click', function(e) {
      var actionBtn = e.target.closest('[data-drawer-qty-action]');
      if (actionBtn) {
        e.stopPropagation();
        var item = actionBtn.closest('[data-drawer-line]');
        if (!item) return;
        var input = item.querySelector('[data-drawer-qty-input]');
        var current = parseInt(input.value, 10) || 0;
        var newQty = actionBtn.dataset.drawerQtyAction === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = newQty;
        updateDrawerLine(parseInt(item.dataset.drawerLine, 10), newQty);
        return;
      }
      var remove = e.target.closest('[data-drawer-remove]');
      if (remove) {
        e.stopPropagation();
        var itemEl = remove.closest('[data-drawer-line]');
        if (itemEl) {
          itemEl.style.opacity = '0';
          itemEl.style.transform = 'translateX(16px)';
          itemEl.style.pointerEvents = 'none';
          updateDrawerLine(parseInt(itemEl.dataset.drawerLine, 10), 0);
        }
      }
    });

    // Qty input direct change (typed). Only react to REAL user events
    // (isTrusted=true); ignore synthetic "change" events dispatched by other
    // click handlers, which would cause duplicate cart updates.
    drawerOverlay.addEventListener('change', function(e) {
      if (!e.isTrusted) return;
      var input = e.target.closest('[data-drawer-qty-input]');
      if (!input) return;
      var item = input.closest('[data-drawer-line]');
      if (!item) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      clearTimeout(_drawerQtyTimer);
      _drawerQtyTimer = setTimeout(function() {
        updateDrawerLine(parseInt(item.dataset.drawerLine, 10), qty);
      }, 250);
    });
  }

  // Hook into add-to-cart success: open drawer on desktop (replaces toast)
  window.openCartDrawer = openCartDrawer;

  /* ==================
     RE-RENDER CART ITEMS
     ================== */
  function showCartItemsLoading() {
    var container = document.getElementById('cart-items-container');
    if (!container) return;
    
    // Create skeleton items
    var html = '';
    for (var i = 0; i < 3; i++) {
      html += '<div class="cart-item is-loading">';
      html += '<div class="cart-item__media"></div>';
      html += '<div class="cart-item__details">';
      html += '<h3></h3>';
      html += '<span class="variant"></span>';
      html += '<div class="item-price"></div>';
      html += '<div class="cart-item__actions"><div class="qty-wrap">';
      html += '<button class="qty-btn">&minus;</button>';
      html += '<input class="qty-input">';
      html += '<button class="qty-btn">&plus;</button></div>';
      html += '<button class="cart-item__remove"></button></div>';
      html += '</div></div>';
    }
    container.innerHTML = html;
  }
  
  // Read the productId -> isBouquet map that Liquid renders inside
  // #cart-bouquet-flags on the cart page. This is reliable because Liquid
  // has full access to product.tags, while the /cart/change.js JSON response
  // may or may not include item.tags in a parseable form.
  // Also merge from current DOM (fallback for items added dynamically).
  function getBouquetFlagMap() {
    var map = {};
    // Primary: window.YomikoeBouquetFlags rendered inline by main-cart.liquid.
    // This is guaranteed available before DOMContentLoaded and survives any
    // subsequent DOM manipulation (including showCartItemsLoading skeletons).
    if (window.YomikoeBouquetFlags && typeof window.YomikoeBouquetFlags === 'object') {
      Object.keys(window.YomikoeBouquetFlags).forEach(function(k) {
        map[k] = !!window.YomikoeBouquetFlags[k];
      });
    }
    // Merge in any items already in the DOM (e.g., freshly added via recommend
    // popup) so we don't lose flags we've already computed.
    document.querySelectorAll('.cart-item[data-product-id]').forEach(function(it) {
      var pid = it.getAttribute('data-product-id');
      var flag = it.getAttribute('data-is-bouquet');
      if (pid && !map.hasOwnProperty(pid) && (flag === 'true' || flag === 'false')) {
        map[pid] = flag === 'true';
      }
    });
    return map;
  }

  function reRenderCartItems(cart) {
    var container = document.getElementById('cart-items-container');
    if (!container) return;
    var html = '';
    var bouquetTag = (CS.bouquetTag || 'bouquet').toLowerCase();
    var bouquetFlagMap = getBouquetFlagMap();
    cart.items.forEach(function(item, i) {
      var line = i + 1;
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
      var noteVal = (item.properties && item.properties['Message Note']) || '';
      var hasNote = noteVal.trim() !== '';
      
      // Primary source of truth: productId -> isBouquet map taken from the
      // initial Liquid-rendered DOM. Falls back to item.tags (may be array OR
      // comma-separated string depending on Shopify response), then product.tags.
      var isBouquet;
      if (item.product_id && bouquetFlagMap.hasOwnProperty(String(item.product_id))) {
        isBouquet = bouquetFlagMap[String(item.product_id)];
      } else {
        var rawTags = item.tags || (item.product && item.product.tags) || [];
        var tagsArr = Array.isArray(rawTags) ? rawTags : String(rawTags).split(',');
        isBouquet = tagsArr.some(function(t) {
          return String(t).trim().toLowerCase() === bouquetTag;
        });
      }
      var showNoteField = isBouquet || hasNote;
      
      html += '<div class="cart-item is-loading" data-item-key="' + item.key + '" data-product-id="' + item.product_id + '" data-is-bouquet="' + isBouquet + '">';
      html += '<a href="' + item.url + '" class="cart-item__media">';
      if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + escHtml(item.title) + '" loading="lazy" width="100" height="130">';
      html += '</a><div class="cart-item__details">';
      html += '<h3><a href="' + item.url + '">' + escHtml(item.title) + '</a></h3>';
      if (item.variant_title && item.variant_title !== 'Default Title') html += '<span class="variant">' + escHtml(item.variant_title) + '</span>';
      html += '<div class="item-price">';
      var comparePrices = getCartComparePrices();
      var compareAtPrice = comparePrices[item.variant_id] || 0;
      var lineCompare = compareAtPrice > item.price ? compareAtPrice * item.quantity : 0;
      if (lineCompare > 0) {
        html += '<span class="item-price__compare">' + formatMoney(lineCompare) + '</span>';
        html += '<span class="item-price__unit">' + formatMoney(item.price) + '</span>';
        html += '<span class="item-price__discount">' + (window.YomikoeCartStrings.youSave || 'AHORR\u00c1S') + ' ' + formatMoney(lineCompare - item.final_line_price) + '</span>';
      } else {
        html += '<span class="item-price__unit">' + formatMoney(item.price) + '</span>';
      }
      if (item.quantity > 1) {
        html += '<span class="item-price__total">' + formatMoney(item.final_line_price) + '</span>';
      }
      html += '</div>';
      html += '<div class="cart-item__actions"><div class="qty-wrap">';
      html += '<button type="button" class="qty-btn" data-action="decrease">&minus;</button>';
      html += '<input type="number" value="' + item.quantity + '" min="0" class="qty-input cart-qty-input" data-line="' + line + '">';
      html += '<button type="button" class="qty-btn" data-action="increase">&plus;</button></div>';
      html += '<button type="button" class="cart-item__remove" data-line="' + line + '">' + escHtml(CS.remove || 'Eliminar') + '</button></div>';
      
      // Note display/edit section
      if (showNoteField) {
        html += '<div class="cart-item__note-wrapper">';
        if (hasNote) {
          html += '<div class="cart-item__note-display" id="note-display-' + line + '">';
          html += '<span class="cart-item__note-label">' + escHtml(CS.noteLabel || 'Nota') + ':</span>';
          html += '<span class="cart-item__note-text">"' + escHtml(noteVal) + '"</span>';
          html += '<button type="button" class="cart-item__note-edit-btn" data-line="' + line + '" aria-label="' + escHtml(CS.editNote || 'Editar nota') + '">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>';
          html += '</button></div>';
        } else {
          // Show "Add note" button instead of textarea directly
          html += '<button type="button" class="cart-item__note-add-btn" data-line="' + line + '">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg> ';
          html += escHtml(CS.addNote || 'Agregar nota');
          html += '</button>';
        }
        html += '<div class="cart-item__note-edit" id="note-edit-' + line + '">';
        html += '<label for="note-' + line + '">' + escHtml(CS.messageNote || 'Nota') + '</label>';
        html += '<textarea id="note-' + line + '" class="cart-item-note-input" data-line="' + line + '" data-key="Message Note" maxlength="200" placeholder="' + escHtml(CS.messageNotePlaceholder || 'Escribe tu mensaje...') + '">' + escHtml(noteVal) + '</textarea>';
        html += '</div></div>';
      }
      
      html += '</div></div>';
    });
    container.innerHTML = html;
    initMaxLengthIn(container);
    
    // Animate items in with staggered delay
    var items = container.querySelectorAll('.cart-item');
    items.forEach(function(item, index) {
      setTimeout(function() {
        item.classList.remove('is-loading');
        item.classList.add('animate-in');
      }, 50 + (index * 80)); // Stagger animation: 50ms base + 80ms per item
    });
  }

  /* ==================
     RECOMMEND POPUP
     ================== */
  var recommendPayAction = null; // 'transfer' or 'card'
  var recommendPopupBypassing = false; // true while proceeding after dismiss

  function fetchRecommendations(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(data) { return data.products || []; });
  }

  function getEmbeddedCollectionProducts() {
    var el = document.getElementById('recommend-collection-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch(e) { return []; }
  }

  function fetchProductTags(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) { return (p.tags || []).map(function(t) { return ('' + t).toLowerCase(); }); })
      .catch(function() { return []; });
  }

  function getRecommendationsForCart(cart) {
    var bouquetTag = (S.tagBouquet || 'bouquet').toLowerCase();
    var cartProductIds = [];
    var cartProductTypes = [];
    var cartHandles = [];
    cart.items.forEach(function(item) {
      if (cartProductIds.indexOf(item.product_id) === -1) cartProductIds.push(item.product_id);
      var pt = item.product_type ? item.product_type.toLowerCase() : '';
      if (pt && cartProductTypes.indexOf(pt) === -1) cartProductTypes.push(pt);
      if (item.handle && cartHandles.indexOf(item.handle) === -1) cartHandles.push(item.handle);
    });
    if (!cartProductIds.length) return Promise.resolve([]);

    // Fetch tags for cart products to detect bouquet items
    var tagPromises = cartHandles.slice(0, 5).map(function(h) { return fetchProductTags(h); });

    return Promise.all(tagPromises).then(function(tagResults) {
      var cartTags = [];
      tagResults.forEach(function(tags) { tags.forEach(function(t) { if (cartTags.indexOf(t) === -1) cartTags.push(t); }); });
      var cartHasBouquet = cartTags.indexOf(bouquetTag) !== -1;

      // Use custom collection (embedded Liquid data) if configured, otherwise Shopify recommendations
      var embeddedProducts = getEmbeddedCollectionProducts();
      var usingCustomCollection = embeddedProducts.length > 0;
      var productsPromise;
      if (usingCustomCollection) {
        productsPromise = Promise.resolve(embeddedProducts);
      } else {
        var promises = cartProductIds.slice(0, 3).map(function(pid) { return fetchRecommendations(pid); });
        productsPromise = Promise.all(promises).then(function(results) {
          var all = [];
          results.forEach(function(products) { all = all.concat(products); });
          return all;
        });
      }

      return productsPromise.then(function(all) {
        // Always exclude products already in cart
        var filtered = all.filter(function(p) {
          return cartProductIds.indexOf(p.id) === -1;
        });

        var seen = {};
        filtered = filtered.filter(function(p) {
          if (seen[p.id]) return false;
          seen[p.id] = true;
          return true;
        });

        filtered = filtered.filter(function(p) {
          return p.available && p.variants && p.variants.some(function(v) { return v.available; });
        });

        // Auto-exclude product types only for automatic recommendations (not custom collection)
        if (!usingCustomCollection) {
          filtered = filtered.filter(function(p) {
            var pt = p.product_type ? p.product_type.toLowerCase() : '';
            if (pt && cartProductTypes.indexOf(pt) !== -1) return false;

            if (cartHasBouquet && p.tags) {
              var pTags = typeof p.tags === 'string'
                ? p.tags.split(',').map(function(t) { return t.trim().toLowerCase(); })
                : (Array.isArray(p.tags) ? p.tags.map(function(t) { return ('' + t).toLowerCase(); }) : []);
              if (pTags.indexOf(bouquetTag) !== -1) return false;
            }
            return true;
          });
        }

        return filtered.slice(0, 10);
      });
    });
  }

  // Normalize price to cents. Liquid outputs cents (integer), Recommendations API outputs dollars (string/float).
  function toCents(val) {
    var n = parseFloat(val);
    if (isNaN(n) || n === 0) return 0;
    // If it looks like dollars (has decimal or is small), convert to cents
    // Liquid prices are always integers in cents (e.g. 1999 for $19.99)
    // Recommendations API returns strings like "19.99"
    if (typeof val === 'string' && val.indexOf('.') !== -1) return Math.round(n * 100);
    // If it's already an integer >= 100, assume cents
    if (Number.isInteger(n)) return n;
    // Otherwise assume dollars
    return Math.round(n * 100);
  }

  function renderRecommendPopup(products, cart) {
    var container = document.getElementById('recommend-popup-products');
    if (!container) return;
    if (!products.length) { container.innerHTML = ''; return; }

    var bouquetTag = (S.tagBouquet || 'bouquet').toLowerCase();
    var html = '';
    products.forEach(function(p) {
      var variant = p.variants.find(function(v) { return v.available; }) || p.variants[0];
      var title = p.title;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var priceCents = toCents(variant.price);
      var compareAtCents = toCents(variant.compare_at_price);
      var priceHtml = formatMoney(priceCents);
      var vendorHtml = p.vendor ? '<div class="recommend-card__vendor">' + escHtml(p.vendor) + '</div>' : '';
      var badgeHtml = '';

      if (compareAtCents && compareAtCents > priceCents) {
        var pct = Math.round((1 - priceCents / compareAtCents) * 100);
        badgeHtml = '<span class="recommend-card__badge">-' + pct + '%</span>';
        priceHtml = '<span class="recommend-card__compare">' + formatMoney(compareAtCents) + '</span> ' + priceHtml;
      }

      // Check if product needs note (bouquet tag or has variants)
      var tags = p.tags || '';
      if (typeof tags === 'string') tags = tags.split(',').map(function(t) { return t.trim().toLowerCase(); });
      else if (Array.isArray(tags)) tags = tags.map(function(t) { return ('' + t).toLowerCase(); });
      // Detect real variants: more than one variant, OR at least one option that is not the default "Title"
      var hasVariants = false;
      if (p.variants && p.variants.length > 1) {
        hasVariants = true;
      } else if (p.options && p.options.length > 0) {
        // options may be strings (names) or objects ({name, values})
        var firstOpt = p.options[0];
        var firstName = (firstOpt && typeof firstOpt === 'object') ? firstOpt.name : firstOpt;
        if (!(p.options.length === 1 && firstName === 'Title')) hasVariants = true;
      }
      // In the upsell context we only open the variant popup when there are real variants to choose.
      // Bouquets without variants get added directly (the gift note is not collected here).
      var needsPopup = hasVariants;

      html += '<div class="recommend-card" data-variant-id="' + variant.id + '" data-product-id="' + p.id + '" data-handle="' + escHtml(p.handle) + '" data-needs-popup="' + needsPopup + '">';
      html += '<div class="recommend-card__media">';
      if (img) html += '<img src="' + img + '" alt="' + escHtml(title) + '" loading="lazy" width="300" height="300">';
      html += '</div>';
      html += '<div class="recommend-card__info">';
      html += '<div class="recommend-card__title">' + escHtml(title) + '</div>';
      html += vendorHtml;
      if (badgeHtml) html += '<div class="recommend-card__badges">' + badgeHtml + '</div>';
      html += '<div class="recommend-card__price">' + (hasVariants ? (CS.fromPrice || 'Desde') + ' ' : '') + priceHtml + '</div>';
      html += '<button class="recommend-card__add btn btn--primary btn--full" data-variant-id="' + variant.id + '" data-handle="' + escHtml(p.handle) + '" data-needs-popup="' + needsPopup + '">' + escHtml(CS.addToCart || 'Agregar al carrito') + '</button>';
      html += '</div></div>';
    });
    container.innerHTML = html;
  }

  function updateRecommendPopupSummary(cart) {
    var subtotal = cart.total_price;
    var disc = S.transferDiscount || 10;
    var isTransfer = recommendPayAction === 'transfer';
    var savings = calcCartSavings(cart);

    // Products column: shows subtotal (current cart price)
    document.querySelectorAll('[data-recommend-subtotal]').forEach(function(el) {
      el.textContent = formatMoney(subtotal);
    });

    // Combined discounts: product savings + transfer discount if applicable
    var totalDiscounts = savings.totalSavings;
    var transferDa = 0;
    if (isTransfer) {
      transferDa = Math.round(subtotal * disc / 100);
      totalDiscounts += transferDa;
    }
    var discountsCol = document.querySelector('[data-recommend-discounts-col]');
    if (discountsCol) {
      discountsCol.style.display = totalDiscounts > 0 ? '' : 'none';
    }
    document.querySelectorAll('[data-recommend-total-discounts]').forEach(function(el) {
      el.textContent = totalDiscounts > 0 ? '-' + formatMoney(totalDiscounts) : '';
    });

    // Total
    var finalTotal = isTransfer ? subtotal - transferDa : subtotal;
    document.querySelectorAll('[data-recommend-total]').forEach(function(el) {
      el.textContent = formatMoney(finalTotal);
    });
  }

  function openRecommendPopup(cart, action) {
    var overlay = document.getElementById('recommend-popup-overlay');
    if (!overlay) return Promise.resolve(false);

    // Move overlay to body if it isn't already a direct child (escape section stacking context)
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    recommendPayAction = action;

    return getRecommendationsForCart(cart).then(function(products) {
      if (!products.length) return false;

      renderRecommendPopup(products, cart);
      updateRecommendPopupSummary(cart);
      window.scrollTo(0, 0);
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return true;
    }).catch(function() { return false; });
  }

  function closeRecommendPopup() {
    var overlay = document.getElementById('recommend-popup-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function proceedWithPayAction() {
    closeRecommendPopup();
    recommendPopupBypassing = true;
    if (recommendPayAction === 'transfer') {
      var transferBtn = document.querySelector('.btn--whatsapp-transfer');
      if (transferBtn) transferBtn.click();
    } else {
      window.location.href = '/checkout';
    }
    setTimeout(function() { recommendPopupBypassing = false; }, 500);
  }

  function initRecommendPopup() {
    var overlay = document.getElementById('recommend-popup-overlay');
    if (!overlay) return;

    // X button and "No, gracias" both proceed with payment
    var closeBtn = overlay.querySelector('.recommend-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', proceedWithPayAction);

    var dismissBtn = document.getElementById('recommend-popup-dismiss');
    if (dismissBtn) dismissBtn.addEventListener('click', proceedWithPayAction);

    // Block outside clicks (do nothing when clicking overlay)
    // No Escape key close either

    // Add to cart from recommend popup
    overlay.addEventListener('click', function(e) {
      var btn = e.target.closest('.recommend-card__add');
      if (!btn) return;
      e.preventDefault();

      var handle = btn.dataset.handle;
      var needsPopup = btn.dataset.needsPopup === 'true';

      // If product needs variant/note popup, open it instead of direct add
      if (needsPopup && handle) {
        openVariantPopup(handle);
        return;
      }

      var card = btn.closest('.recommend-card');
      var vid = btn.dataset.variantId;
      if (!vid) return;
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      addToCart(vid, 1, null).then(function(item) {
        showCartNotification(item.title);
        fireAddToCartPixel(item.title || '', item.product_id || item.id, (item.price / 100) || 0, 1);
        if (card) { card.classList.add('is-added'); setTimeout(function() { card.style.display = 'none'; }, 400); }
        return fullCartRefresh();
      }).then(function() {
        return fetchCart();
      }).then(function(cart) {
        updateRecommendPopupSummary(cart);
      }).catch(function() { btn.textContent = orig; btn.disabled = false; });
    });
  }

  function interceptPayButtons() {
    // Intercept ALL pay buttons using capture phase
    // This fires before the navigation loading handler and WhatsApp handler
    document.addEventListener('click', function(e) {
      if (recommendPopupBypassing) return; // let through after dismiss

      var isCheckout = e.target.closest('a[href="/checkout"]');
      var isTransfer = e.target.closest('.btn--whatsapp-transfer');

      if (!isCheckout && !isTransfer) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      // Validate delivery date/time before proceeding
      var dateInput = document.getElementById('delivery-date');
      var timeSelect = document.getElementById('delivery-time');
      var warningEl = document.getElementById('delivery-warning');
      var warningText = document.getElementById('delivery-warning-text');
      if (dateInput && !dateInput.value) {
        if (warningEl && warningText) {
          warningEl.style.display = 'flex';
          warningText.textContent = CS.deliveryDateRequired || 'Elegí una fecha de entrega para continuar.';
        }
        dateInput.focus();
        dateInput.classList.add('is-invalid');
        document.getElementById('cart-delivery').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (dateInput) dateInput.classList.remove('is-invalid');
      if (timeSelect && !timeSelect.value) {
        if (warningEl && warningText) {
          warningEl.style.display = 'flex';
          warningText.textContent = CS.deliveryTimeRequired || 'Elegí una franja horaria para continuar.';
        }
        timeSelect.focus();
        timeSelect.classList.add('is-invalid');
        document.getElementById('cart-delivery').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (timeSelect) timeSelect.classList.remove('is-invalid');
      if (warningEl) warningEl.style.display = 'none';

      var action = isTransfer ? 'transfer' : 'card';

      fetchCart().then(function(cart) {
        openRecommendPopup(cart, action).then(function(opened) {
          if (!opened) {
            // No recommendations, proceed directly
            recommendPopupBypassing = true;
            if (action === 'transfer') {
              var btn = document.querySelector('.btn--whatsapp-transfer');
              if (btn) btn.click();
            } else {
              var coValue = (cart && cart.total_price) ? cart.total_price / 100 : 0;
              pushDataLayer('begin_checkout', {
                checkout_method: 'card',
                value: coValue,
                currency: S.currency || 'ARS'
              });
              fireInitiateCheckoutPixel(coValue, S.currency || 'ARS');
              window.location.href = '/checkout';
            }
            setTimeout(function() { recommendPopupBypassing = false; }, 500);
          }
        });
      }).catch(function() {
        // On error, proceed directly
        if (isCheckout) window.location.href = '/checkout';
      });
    }, true); // capture phase - fires before ALL bubble handlers
  }

  /* ==================
     ADD TO CART
     ================== */
  function addToCart(variantId, qty, properties) {
    var body = { id: parseInt(variantId), quantity: qty || 1 };
    if (properties && Object.keys(properties).length) body.properties = properties;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function(r) { return r.json(); });
  }



  /* ==================
     VARIANT POPUP
     ================== */
  var popupOverlay = document.getElementById('variant-popup-overlay');
  var popupImg = document.getElementById('variant-popup-img');
  var popupTitle = document.getElementById('variant-popup-title');
  var popupPrice = document.getElementById('variant-popup-price');
  var popupOptions = document.getElementById('variant-popup-options');
  var popupNote = document.getElementById('variant-popup-note');
  var popupNoteInput = document.getElementById('variant-popup-note-input');
  var popupQty = document.getElementById('variant-popup-qty');
  var popupAddBtn = document.getElementById('variant-popup-add');
  var currentProductData = null;

  function openVariantPopup(handle) {
    if (!popupOverlay) return;
    
    // Show loading state on image
    if (popupImg) {
      popupImg.classList.remove('is-loaded');
      popupImg.classList.add('is-loading');
      popupImg.parentElement.classList.remove('is-loaded');
    }
    
    fetch('/products/' + handle + '.js').then(function(r) { return r.json(); }).then(function(product) {
      currentProductData = product;
      if (popupImg && product.featured_image) {
        popupImg.src = product.featured_image.replace(/(\.[^.]+)$/, '_600x$1');
        popupImg.alt = product.title;
        popupImg.onload = function() {
          popupImg.classList.remove('is-loading');
          popupImg.classList.add('is-loaded');
          popupImg.parentElement.classList.add('is-loaded');
        };
        // If image is already cached
        if (popupImg.complete && popupImg.naturalWidth > 0) {
          popupImg.classList.remove('is-loading');
          popupImg.classList.add('is-loaded');
          popupImg.parentElement.classList.add('is-loaded');
        }
      } else if (popupImg) {
        popupImg.src = '';
        popupImg.classList.remove('is-loading');
        popupImg.classList.add('is-loaded');
        popupImg.parentElement.classList.add('is-loaded');
      }
      if (popupTitle) popupTitle.textContent = product.title;
      if (popupPrice) popupPrice.textContent = formatMoney(product.price);
      if (popupQty) popupQty.value = 1;
      if (popupOptions) {
        popupOptions.innerHTML = '';
        if (product.options && product.options.length > 0 && !(product.options.length === 1 && product.options[0].name === 'Title')) {
          product.options.forEach(function(opt, i) {
            var lbl = document.createElement('label'); lbl.textContent = opt.name; lbl.setAttribute('for', 'popup-option-' + i);
            var sel = document.createElement('select'); sel.id = 'popup-option-' + i; sel.dataset.optionIndex = i;
            var uv = [];
            opt.values.forEach(function(v) { if (uv.indexOf(v) === -1) { uv.push(v); var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); } });
            sel.addEventListener('change', updatePopupVariant);
            popupOptions.appendChild(lbl); popupOptions.appendChild(sel);
          });
        }
      }
      // Case-insensitive tag check
      var bouquetTag = (S.tagBouquet || 'bouquet').toLowerCase();
      var isBouquet = product.tags && product.tags.some(function(t) { return t.toLowerCase() === bouquetTag; });
      var showGiftMessage = S.showGiftMessageAll || isBouquet;
      if (popupNote) popupNote.style.display = showGiftMessage ? 'block' : 'none';
      if (popupNoteInput) { popupNoteInput.value = ''; popupNoteInput.maxLength = 200; }
      updatePopupVariant();
      // Compact mode when opened from the upsell/recommend popup
      var recOverlay = document.getElementById('recommend-popup-overlay');
      var fromUpsell = recOverlay && recOverlay.classList.contains('is-visible');
      popupOverlay.classList.toggle('variant-popup-overlay--compact', !!fromUpsell);
      // Hide note in compact/upsell mode regardless of bouquet tag
      if (popupNote && fromUpsell) popupNote.style.display = 'none';
      popupOverlay.classList.add('is-visible'); popupOverlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    });
  }
  function updatePopupVariant() {
    if (!currentProductData) return;
    var sels = popupOptions ? popupOptions.querySelectorAll('select') : [], opts = [];
    sels.forEach(function(s) { opts.push(s.value); });
    var v = currentProductData.variants.find(function(va) { if (!opts.length) return true; return opts.every(function(o, i) { return va.options[i] === o; }); }) || currentProductData.variants[0];
    if (popupPrice) { var h = formatMoney(v.price); if (v.compare_at_price && v.compare_at_price > v.price) h = '<span style="text-decoration:line-through;color:var(--color-border);font-size:.9rem;margin-right:.4rem;">' + formatMoney(v.compare_at_price) + '</span> ' + h; popupPrice.innerHTML = h; }
    if (popupAddBtn) { popupAddBtn.dataset.variantId = v.id; popupAddBtn.disabled = !v.available; }
    
    // Update image if variant has a featured image
    if (popupImg && v.featured_image) {
      popupImg.classList.remove('is-loaded');
      popupImg.classList.add('is-loading');
      if (popupImg.parentElement) popupImg.parentElement.classList.remove('is-loaded');
      
      var newSrc = v.featured_image.src ? v.featured_image.src.replace(/(\.[^.]+)$/, '_600x$1') : '';
      if (newSrc) {
        popupImg.onload = function() {
          popupImg.classList.remove('is-loading');
          popupImg.classList.add('is-loaded');
          if (popupImg.parentElement) popupImg.parentElement.classList.add('is-loaded');
        };
        popupImg.src = newSrc;
      }
    }
  }
  function closeVariantPopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('is-visible');
    popupOverlay.classList.remove('variant-popup-overlay--compact');
    popupOverlay.setAttribute('aria-hidden', 'true');
    currentProductData = null;
    // If recommend popup is still open, keep body scroll locked and refresh its summary
    var recOverlay = document.getElementById('recommend-popup-overlay');
    if (recOverlay && recOverlay.classList.contains('is-visible')) {
      document.body.style.overflow = 'hidden';
      fetchCart().then(function(cart) { updateRecommendPopupSummary(cart); });
    } else {
      document.body.style.overflow = '';
    }
  }
  function initVariantPopup() {
    if (!popupOverlay) return;
    var cb = popupOverlay.querySelector('.variant-popup__close'); if (cb) cb.addEventListener('click', closeVariantPopup);
    popupOverlay.addEventListener('click', function(e) { if (e.target === popupOverlay) closeVariantPopup(); });
    if (popupAddBtn) {
      popupAddBtn.addEventListener('click', function() {
        var vid = this.dataset.variantId; if (!vid) return;
        var qty = popupQty ? parseInt(popupQty.value) || 1 : 1;
        var props = {};
        if (popupNote && popupNote.style.display !== 'none' && popupNoteInput && popupNoteInput.value.trim()) props['Message Note'] = popupNoteInput.value.trim().substring(0, 200);
        var orig = this.textContent;
        this.classList.add('is-loading');
        this.disabled = true;
        var startTime = Date.now();
        addToCart(vid, qty, props).then(function(item) {
          var elapsed = Date.now() - startTime;
          var minDelay = Math.max(0, 600 - elapsed);
          setTimeout(function() {
            popupAddBtn.classList.remove('is-loading');
            popupAddBtn.textContent = '\u2713';
            popupAddBtn.classList.add('btn-success');
            showCartNotification(item.title); 
            fullCartRefresh(); 
            setTimeout(function() {
              closeVariantPopup();
              popupAddBtn.textContent = orig;
              popupAddBtn.disabled = false;
              popupAddBtn.classList.remove('btn-success');
            }, 800);
          }, minDelay);
        }).catch(function() { 
          popupAddBtn.classList.remove('is-loading');
          popupAddBtn.textContent = orig; 
          popupAddBtn.disabled = false; 
        });
      });
    }
  }

  /* ==================
     QUICK ADD + PRODUCT CARD INTERACTIONS
     ================== */
  function initQuickAdd() {
    // Handle quick buy button clicks
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__quick-buy');
      if (!btn) return;
      // Quote products: handled by initRequestQuote, skip here
      if (btn.dataset.requestQuote === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      
      var handle = btn.dataset.handle;
      var hasV = btn.dataset.hasVariants === 'true';
      var showGift = btn.dataset.showGiftMessage === 'true';
      
      if (hasV || showGift) {
        openVariantPopup(handle);
      } else {
        var vid = btn.dataset.variantId;
        if (!vid) return;
        
        var orig = btn.textContent;
        var card = btn.closest('.product-card');
        
        // Prevent card click handler from firing
        if (card) card.dataset.buttonClicked = 'true';
        
        // Force button visible and show loading spinner
        btn.classList.add('force-visible', 'is-loading');
        btn.disabled = true;
        
        var startTime = Date.now();
        
        addToCart(vid, 1, null).then(function(item) {
          fireAddToCartPixel(item.title || '', item.product_id || item.id, (item.price / 100) || 0, 1);
          // Calculate remaining time for minimum 0.5s loading
          var elapsed = Date.now() - startTime;
          var remainingDelay = Math.max(0, 500 - elapsed);
          
          setTimeout(function() {
            // Show success state
            btn.classList.remove('is-loading');
            btn.textContent = '\u2713';
            btn.classList.add('is-success');
            showCartNotification(item.title);
            fullCartRefresh();
            
            // After 0.7s, return to original state
            setTimeout(function() {
              btn.textContent = orig;
              btn.disabled = false;
              btn.classList.remove('is-success');
              if (card) delete card.dataset.buttonClicked;
              
              // Check if mouse is still hovering the card
              // If not, remove force-visible to let button hide
              if (card && !card.matches(':hover')) {
                btn.classList.remove('force-visible');
              }
            }, 700);
          }, remainingDelay);
        }).catch(function() {
          btn.classList.remove('is-loading', 'force-visible');
          btn.textContent = orig;
          btn.disabled = false;
          if (card) delete card.dataset.buttonClicked;
        });
      }
    });
    
    // Handle card clicks (navigate to product page)
    document.addEventListener('click', function(e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      
      // Don't trigger if button was clicked
      if (card.dataset.buttonClicked === 'true') return;
      
      // Don't trigger if clicking on the quick-buy button
      if (e.target.closest('.product-card__quick-buy')) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      // Get product URL from any link in the card
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      
      var productUrl = link.href;
      
      // Press animation
      card.classList.add('card-pressed');
      
      // Unpress animation after 100ms
      setTimeout(function() {
        card.classList.remove('card-pressed');
        card.classList.add('card-unpress');
      }, 100);
      
      // Navigate after complete animation
      setTimeout(function() {
        window.location.href = productUrl;
      }, 200);
    });
  }
  function initAddToCartForm() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form[action*="/cart/add"]'); if (!form) return; e.preventDefault();
      var btn = form.querySelector('[type="submit"]'); var orig = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;
      var startTime = Date.now();
      var fd = new FormData(form); var body = { id: parseInt(fd.get('id')), quantity: parseInt(fd.get('quantity')) || 1 };
      var props = {};
      fd.forEach(function(v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v.trim()) props[m[1]] = v.trim().substring(0, 200); });
      if (Object.keys(props).length) body.properties = props;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function(r) { return r.json(); }).then(function(item) {
          if (item.id) {
            pushDataLayer('add_to_cart', {
              product_title: item.title || '',
              product_id: item.product_id || item.id,
              variant_id: item.variant_id || item.id,
              product_price: (item.price / 100) || 0,
              quantity: body.quantity,
              currency: S.currency || 'ARS'
            });
            fireAddToCartPixel(item.title || '', item.product_id || item.id, (item.price / 100) || 0, body.quantity);
          }
          var elapsed = Date.now() - startTime;
          var minDelay = Math.max(0, 600 - elapsed);
          setTimeout(function() {
            btn.classList.remove('is-loading');
            btn.textContent = btn.dataset.added || '\u2713';
            btn.classList.add('btn-success');
            showCartNotification(item.title); 
            fullCartRefresh(); 
            setTimeout(function() { 
              btn.textContent = orig; 
              btn.disabled = false;
              btn.classList.remove('btn-success');
            }, 1200);
          }, minDelay);
        })
        .catch(function() { 
          btn.classList.remove('is-loading');
          btn.textContent = orig; 
          btn.disabled = false; 
        });
    });
  }

  /* ==================
     CART LINE UPDATES
     ================== */
  function initCartUpdates() {
    var qtyTimer = null;
    var noteSaveTimer = null;
    document.addEventListener('change', function(e) {
      var input = e.target.closest('.cart-qty-input');
      if (input) { clearTimeout(qtyTimer); var line = parseInt(input.dataset.line), qty = parseInt(input.value); if (isNaN(qty) || qty < 0) qty = 0; qtyTimer = setTimeout(function() { updateCartLine(line, qty); }, 300); return; }
    });
    // "Add note" button - show textarea
    document.addEventListener('click', function(e) {
      var addBtn = e.target.closest('.cart-item__note-add-btn'); if (!addBtn) return;
      var line = parseInt(addBtn.dataset.line);
      var editContainer = document.getElementById('note-edit-' + line);
      if (editContainer) {
        editContainer.classList.add('is-visible');
        addBtn.style.display = 'none';
        var textarea = editContainer.querySelector('textarea');
        if (textarea) textarea.focus();
      }
    });
    // Note edit button - show textarea
    document.addEventListener('click', function(e) {
      var editBtn = e.target.closest('.cart-item__note-edit-btn'); if (!editBtn) return;
      var line = parseInt(editBtn.dataset.line);
      var editContainer = document.getElementById('note-edit-' + line);
      var displayContainer = document.getElementById('note-display-' + line);
      if (editContainer) {
        editContainer.classList.add('is-visible');
        if (displayContainer) displayContainer.style.display = 'none';
        var textarea = editContainer.querySelector('textarea');
        if (textarea) textarea.focus();
      }
    });
    // Auto-save note on blur (leaving textarea)
    document.addEventListener('focusout', function(e) {
      var textarea = e.target.closest('.cart-item-note-input');
      if (textarea) {
        clearTimeout(noteSaveTimer);
        noteSaveTimer = setTimeout(function() { saveCartItemNote(textarea); }, 100);
      }
    });
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-item__remove'); if (!btn) return; e.preventDefault();
      var line = parseInt(btn.dataset.line), item = btn.closest('.cart-item');
      if (item) { item.style.opacity = '0'; item.style.transform = 'translateX(-20px)'; item.style.pointerEvents = 'none'; }
      updateCartLine(line, 0);
    });
  }
  function updateCartLine(line, quantity) {
    // Show loading state
    showCartItemsLoading();
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
    .then(function(r) { return r.json(); }).then(function(cart) { if (cart.item_count === 0) { location.reload(); return; } reRenderCartItems(cart); refreshCartTotals(cart); });
  }
  function saveCartItemNote(noteInput) {
    var line = parseInt(noteInput.dataset.line), note = noteInput.value.substring(0, 200); noteInput.value = note;
    var key = noteInput.dataset.key || 'Message Note';
    var editContainer = document.getElementById('note-edit-' + line);
    var displayContainer = document.getElementById('note-display-' + line);
    var noteWrapper = noteInput.closest('.cart-item__note-wrapper');
    var cartItem = noteInput.closest('.cart-item');
    var isBouquet = cartItem && cartItem.dataset.isBouquet === 'true';
    
    fetchCart().then(function(cart) {
      var item = cart.items[line - 1];
      if (!item) return;
      var props = Object.assign({}, item.properties || {});
      if (note.trim()) props[key] = note.trim();
      else delete props[key];
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: item.quantity, properties: props }) });
    }).then(function() {
      if (note.trim()) {
        // Has note - show display mode
        if (editContainer) editContainer.classList.remove('is-visible');
        
        // Create display container if it doesn't exist
        if (!displayContainer && noteWrapper) {
          displayContainer = document.createElement('div');
          displayContainer.className = 'cart-item__note-display';
          displayContainer.id = 'note-display-' + line;
          displayContainer.innerHTML = '<span class="cart-item__note-label">' + (CS.noteLabel || 'Nota') + ':</span><span class="cart-item__note-text">"' + note + '"</span><button type="button" class="cart-item__note-edit-btn" data-line="' + line + '" aria-label="' + (CS.editNote || 'Editar nota') + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></button>';
          noteWrapper.insertBefore(displayContainer, editContainer);
        } else if (displayContainer) {
          var noteText = displayContainer.querySelector('.cart-item__note-text');
          if (noteText) noteText.textContent = '"' + note + '"';
          displayContainer.style.display = '';
        }
      } else {
        // Empty note - hide textarea and show "Add note" button
        if (editContainer) editContainer.classList.remove('is-visible');
        if (displayContainer) displayContainer.style.display = 'none';
        
        // Create or show "Add note" button for bouquet items
        if (isBouquet && noteWrapper) {
          var addBtn = noteWrapper.querySelector('.cart-item__note-add-btn');
          if (!addBtn) {
            addBtn = document.createElement('button');
            addBtn.type = 'button';
            addBtn.className = 'cart-item__note-add-btn';
            addBtn.dataset.line = line;
            addBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg> ' + (CS.addNote || 'Agregar nota');
            noteWrapper.insertBefore(addBtn, editContainer);
          } else {
            addBtn.style.display = '';
          }
        }
      }
    });
  }

  /* ==================
     DELIVERY DATE/TIME
     ================== */
  function initDeliveryPicker() {
    var dateInput = document.getElementById('delivery-date');
    var timeSelect = document.getElementById('delivery-time');
    var warningEl = document.getElementById('delivery-warning');
    var warningText = document.getElementById('delivery-warning-text');
    if (!dateInput || !timeSelect) return;

    function dpDateStr(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    // Earliest deliverable date: today if still before today's fabrication cutoff, else next fabrication day.
    function earliestDeliveryDate() {
      var now = ykStoreNow();
      if (isNaN(now.getTime())) now = new Date();
      var base = new Date(now); base.setHours(0, 0, 0, 0);
      if (!window.YomikoeStoreHours) return base;
      var nowMin = now.getHours() * 60 + now.getMinutes();
      var todayCut = ykFabCutoff(base.getDay());
      if (todayCut !== null && nowMin < todayCut) return base;
      for (var i = 1; i <= 7; i++) {
        var d = new Date(base); d.setDate(base.getDate() + i);
        if (ykFabCutoff(d.getDay()) !== null) return d;
      }
      return base;
    }

    var earliestStr = dpDateStr(earliestDeliveryDate());
    dateInput.setAttribute('min', earliestStr);
    // Clear a stale pre-filled date that is no longer allowed (e.g. "today" after the cutoff)
    if (dateInput.value && dateInput.value < earliestStr) dateInput.value = '';

    // Populate time slots from shop metafield
    var slotsRaw = window.YomikoeDeliverySlots || '';
    var slots = slotsRaw.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    slots.forEach(function(slot) {
      var opt = document.createElement('option');
      opt.value = slot; opt.textContent = slot;
      timeSelect.appendChild(opt);
    });

    // Restore saved values
    var savedTime = null;
    fetch('/cart.json').then(function(r) { return r.json(); }).then(function(cart) {
      if (cart.attributes) {
        if (cart.attributes['Delivery Date'] && !dateInput.value) {
          var savedD = cart.attributes['Delivery Date'];
          if (savedD >= earliestStr) dateInput.value = savedD;
        }
        if (cart.attributes['Delivery Time']) {
          savedTime = cart.attributes['Delivery Time'];
          timeSelect.value = savedTime;
        }
      }
      checkDateWarning();
    });

    function saveAttributes() {
      var body = { attributes: { 'Delivery Date': dateInput.value, 'Delivery Time': timeSelect.value } };
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    }

    // Parse the end time (minutes since midnight) of a slot like "9:00 - 12:00"
    function parseSlotEndMinutes(slot) {
      var parts = String(slot).split('-');
      if (parts.length < 2) return null;
      var end = parts[parts.length - 1].trim().split(':');
      var h = parseInt(end[0], 10);
      if (isNaN(h)) return null;
      var min = parseInt(end[1], 10);
      return h * 60 + (isNaN(min) ? 0 : min);
    }

    // Same-day cutoff: a slot stops being orderable 2hs before it ends.
    // Disables past-cutoff slots when "today" is selected; returns true if a slot remains.
    function applyTodayCutoff(isToday) {
      var now = ykStoreNow();
      var nowMin = now.getHours() * 60 + now.getMinutes();
      var anyAvailable = false;
      Array.prototype.forEach.call(timeSelect.options, function(opt) {
        if (!opt.value) return; // placeholder
        if (!isToday) { opt.disabled = false; opt.hidden = false; anyAvailable = true; return; }
        var end = parseSlotEndMinutes(opt.value);
        if (end == null) { opt.disabled = false; opt.hidden = false; anyAvailable = true; return; }
        var past = nowMin >= (end - 120);
        opt.disabled = past;
        opt.hidden = past;
        if (!past) anyAvailable = true;
      });
      if (timeSelect.value) {
        var sel = timeSelect.options[timeSelect.selectedIndex];
        if (sel && sel.disabled) { timeSelect.value = ''; saveAttributes(); }
      }
      return anyAvailable;
    }

    function checkDateWarning() {
      if (!warningEl || !warningText) return;
      var val = dateInput.value;
      if (!val) { warningEl.style.display = 'none'; return; }

      var selected = new Date(val + 'T00:00:00');
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var diffDays = Math.round((selected - now) / 86400000);
      var isSunday = selected.getDay() === 0;
      var isToday = diffDays === 0;

      // Apply the same-day slot cutoff (2hs before each slot ends)
      var slotAvailable = applyTodayCutoff(isToday);

      // Products tagged "Entrega Hoy" are deliverable same-day → skip the 48hs WhatsApp alert
      var allEntregaHoy = window.YomikoeCartAllEntregaHoy === true;

      // Entrega Hoy + today but cutoff already passed for every slot: neutral message, no WhatsApp
      if (isToday && allEntregaHoy && !slotAvailable) {
        warningEl.style.display = 'flex';
        warningText.textContent = CS.deliveryCutoffPassed || 'Hoy ya cerró el horario de pedidos. Elegí el próximo día disponible.';
        return;
      }

      // Sunday same-day check (kept regardless of tag)
      if (isSunday && isToday) {
        warningEl.style.display = 'flex';
        warningText.innerHTML = CS.deliverySundayWarning || 'No trabajamos los domingos. Consultá disponibilidad.';
        addWhatsAppLink();
        return;
      }

      // Urgent: today or next 2 days → WhatsApp, unless every item is "Entrega Hoy"
      if (diffDays >= 0 && diffDays <= 2 && !allEntregaHoy) {
        warningEl.style.display = 'flex';
        warningText.innerHTML = CS.deliveryUrgentWarning || 'Para entregas en las próximas 48hs, consultá disponibilidad.';
        addWhatsAppLink();
        return;
      }

      warningEl.style.display = 'none';
    }

    function addWhatsAppLink() {
      if (!warningText) return;
      var phone = S.whatsappNumber || '';
      if (!phone) return;
      var existingLink = warningText.querySelector('a');
      if (existingLink) return;
      var msg = buildUrgentWhatsAppMessage();
      var link = document.createElement('a');
      link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
      link.target = '_blank';
      link.textContent = ' ' + (CS.deliveryContactUs || 'Consultanos por WhatsApp');
      warningText.appendChild(link);
    }

    function buildUrgentWhatsAppMessage() {
      var lines = ['Hola! Quiero consultar disponibilidad para mi pedido:', ''];
      var cartItems = document.querySelectorAll('.cart-item');
      cartItems.forEach(function(el, i) {
        var titleEl = el.querySelector('.cart-item__details h3 a');
        var qtyEl = el.querySelector('.qty-input');
        if (titleEl) {
          var l = (i + 1) + '. ' + titleEl.textContent.trim();
          if (qtyEl) l += ' x' + qtyEl.value;
          lines.push(l);
        }
      });
      lines.push('', 'Fecha deseada: ' + dateInput.value);
      if (timeSelect.value) lines.push('Franja horaria: ' + timeSelect.value);
      lines.push('', '¿Tienen disponibilidad para esta fecha?');
      return lines.join('\n');
    }

    // Expose so the cart can re-evaluate the notice after AJAX item changes
    window.YomikoeRefreshDelivery = checkDateWarning;

    dateInput.addEventListener('change', function() { checkDateWarning(); saveAttributes(); });
    timeSelect.addEventListener('change', function() { saveAttributes(); });
  }

  /* ==================
     REQUEST QUOTE (WhatsApp)
     ================== */
  function initRequestQuote() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-request-quote="true"]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var title = btn.dataset.productTitle || '';
      var url = btn.dataset.productUrl || '';
      var id = btn.dataset.productId || '';
      var price = btn.dataset.productPrice || 0;
      var phone = (S.whatsappNumber || '').replace(/\D/g, '');
      var greeting = S.quoteGreeting || 'Hola! Quiero pedir un presupuesto para este producto:';
      var followUp = S.quoteFollowUp || '¿Podrían enviarme más información y precio?';

      var lines = [greeting, '', title];
      if (url) lines.push(url);
      lines.push('', followUp);

      fireQuoteAnalytics(title, id, price);
      var waUrl = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n'));
      window.open(waUrl, '_blank');
    });
  }

  /* ==================
     WHATSAPP TRANSFER
     ================== */
  function initWhatsAppTransfer() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.btn--whatsapp-transfer'); if (!btn) return; e.preventDefault();
      fetchCart().then(function(cart) {
        var disc = S.transferDiscount || 10, greet = S.whatsappGreeting || 'Hola!', phone = S.whatsappNumber || '';
        var dateInput = document.getElementById('delivery-date');
        var timeSelect = document.getElementById('delivery-time');
        var lines = [greet, ''];
        cart.items.forEach(function(item, i) {
          var l = (i + 1) + '. ' + item.title;
          if (item.variant_title && item.variant_title !== 'Default Title') l += ' (' + item.variant_title + ')';
          l += ' x' + item.quantity + ' - ' + formatMoney(item.final_line_price);
          if (item.properties) Object.keys(item.properties).forEach(function(k) { if (item.properties[k]) l += '\n   ' + k + ': ' + item.properties[k]; });
          lines.push(l);
        });
        var da = Math.round(cart.total_price * disc / 100), tt = cart.total_price - da;
        lines.push('', 'Subtotal: ' + formatMoney(cart.total_price), 'Descuento transferencia (' + disc + '%): -' + formatMoney(da), 'TOTAL: ' + formatMoney(tt), 'Moneda: ' + (S.currency || cart.currency));
        if (dateInput && dateInput.value) lines.push('', 'Fecha de entrega: ' + dateInput.value);
        if (timeSelect && timeSelect.value) lines.push('Franja horaria: ' + timeSelect.value);
        fireTransferAnalytics(tt, cart.currency);
        window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n')), '_blank');
      });
    });
  }

  /* ==================
     ANALYTICS - dataLayer pushes (GTM reads these)
     ================== */
  function pushDataLayer(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = data || {};
    payload.event = event;
    payload.ecommerce = undefined; // prevent GTM e-commerce merging issues
    window.dataLayer.push(payload);
  }

  function pushWhatsAppClick(source, extra) {
    var data = {
      contact_method: 'whatsapp',
      whatsapp_source: source || 'link',
      page_path: location.pathname,
      page_template: (document.body && document.body.dataset && document.body.dataset.template) || ''
    };
    if (extra) {
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k];
    }
    pushDataLayer('whatsapp_click', data);
  }

  function initWhatsAppLinkTracking() {
    function getLocationArea(a) {
      var container = a.closest('header, footer, [data-whatsapp-float], .cart-sidebar, main, section');
      if (!container) return 'unknown';
      if (container.tagName === 'HEADER') return 'header';
      if (container.tagName === 'FOOTER') return 'footer';
      if (container.matches('[data-whatsapp-float]')) return 'floating_popup';
      if (container.matches('.cart-sidebar')) return 'cart';
      return container.tagName.toLowerCase();
    }

    function basePayload(a) {
      return {
        contact_method: 'whatsapp',
        whatsapp_source: 'link',
        page_path: location.pathname,
        page_template: (document.body && document.body.dataset && document.body.dataset.template) || '',
        link_url: a.href,
        link_text: ((a.innerText || a.getAttribute('aria-label') || '').trim()).slice(0, 80),
        link_location: getLocationArea(a)
      };
    }

    document.addEventListener('click', function(e) {
      var a = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
      if (!a || e.button !== 0) return;

      var modifierClick = e.ctrlKey || e.metaKey || e.shiftKey;
      var payload = basePayload(a);
      payload.event = 'whatsapp_click';

      if (modifierClick) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        return;
      }

      var href = a.href;
      var openInNewTab = a.target === '_blank';
      var navigated = false;
      var navigate = function () {
        if (navigated) return;
        navigated = true;
        if (openInNewTab) window.open(href, '_blank', 'noopener');
        else window.location.href = href;
      };

      e.preventDefault();
      payload.eventCallback = navigate;
      payload.eventTimeout = 1200;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      setTimeout(navigate, 1200);
    }, true);

    document.addEventListener('auxclick', function(e) {
      if (e.button !== 1) return;
      var a = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
      if (!a) return;
      var payload = basePayload(a);
      payload.event = 'whatsapp_click';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }, true);
  }

  function fireTransferAnalytics(totalCents, currency) {
    var v = totalCents / 100;
    var data = {
      value: v,
      currency: currency || 'ARS',
      contact_method: 'whatsapp_transfer'
    };
    pushDataLayer('whatsapp_transfer', data);
    pushWhatsAppClick('transfer', { value: v, currency: currency || 'ARS' });
    if (window.fbq) fbq('track', 'Lead', { value: v, currency: currency || 'ARS', content_name: 'whatsapp_transfer' });
  }

  function fireWhatsAppContactAnalytics(optionLabel, pageType, contextData) {
    var data = {
      contact_method: 'whatsapp_popup',
      option_label: optionLabel || '',
      page_type: pageType || ''
    };
    if (contextData) {
      if (contextData.productTitle) data.product_title = contextData.productTitle;
      if (contextData.productId) data.product_id = contextData.productId;
      if (contextData.productPrice) data.product_price = contextData.productPrice;
      if (contextData.productCollection) data.product_collection = contextData.productCollection;
      if (contextData.collectionTitle) data.collection_title = contextData.collectionTitle;
      if (contextData.collectionId) data.collection_id = contextData.collectionId;
    }
    pushDataLayer('whatsapp_contact', data);
    pushWhatsAppClick('popup', {
      option_label: data.option_label,
      page_type: data.page_type,
      product_id: data.product_id || '',
      product_title: data.product_title || '',
      collection_id: data.collection_id || '',
      collection_title: data.collection_title || ''
    });
    if (window.fbq) fbq('track', 'Lead', { content_name: 'whatsapp_popup', content_category: pageType || '' });
  }

  function fireQuoteAnalytics(productTitle, productId, productPrice) {
    var data = {
      contact_method: 'whatsapp_quote',
      product_title: productTitle || '',
      product_id: productId || '',
      product_price: productPrice || 0
    };
    pushDataLayer('whatsapp_quote', data);
    pushWhatsAppClick('quote', {
      product_title: data.product_title,
      product_id: data.product_id,
      product_price: data.product_price
    });
    if (window.fbq) fbq('track', 'Lead', { content_name: 'whatsapp_quote', content_category: 'product' });
  }

  /* ==================
     INSTAGRAM LINK TRACKING
     ================== */
  function initInstagramLinkTracking() {
    document.addEventListener('click', function(e) {
      var a = e.target.closest('a[href*="instagram.com"]');
      if (!a || e.button !== 0) return;

      var linkText = ((a.innerText || a.getAttribute('aria-label') || '').trim()).slice(0, 80);
      var container = a.closest('header, footer, main, section');
      var linkLocation = 'unknown';
      if (container) {
        if (container.tagName === 'HEADER') linkLocation = 'header';
        else if (container.tagName === 'FOOTER') linkLocation = 'footer';
        else linkLocation = container.tagName.toLowerCase();
      }

      pushDataLayer('instagram_click', {
        contact_method: 'instagram',
        link_location: linkLocation,
        link_text: linkText,
        page_path: location.pathname
      });
      if (window.fbq) fbq('track', 'Lead', { content_name: 'instagram_click', content_category: linkLocation });
    }, true);
  }

  /* ==================
     META PIXEL - PAGE & ECOMMERCE EVENTS
     ================== */
  function initMetaPixelPageEvents() {
    if (!window.fbq) return;

    var templateName = document.body.className.match(/template-(\S+)/);
    templateName = templateName ? templateName[1] : '';

    if (templateName === 'product') {
      var pTitle = document.querySelector('.product-gallery, [data-product-title]');
      var titleEl = pTitle ? pTitle.querySelector('h1, [data-product-title]') : document.querySelector('h1');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var pId = document.querySelector('[data-product-id]');
      var productId = pId ? pId.getAttribute('data-product-id') || pId.value : '';
      var priceEl = document.querySelector('[data-product-price], .product-price .price, #current-price');
      var price = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0 : 0;
      fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: title,
        content_ids: [productId],
        value: price,
        currency: S.currency || 'ARS'
      });
    } else if (templateName === 'collection') {
      fbq('track', 'ViewContent', {
        content_type: 'product_group',
        content_name: document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : ''
      });
    }
  }

  function fireAddToCartPixel(itemTitle, itemId, itemPrice, qty) {
    if (window.fbq) {
      fbq('track', 'AddToCart', {
        content_type: 'product',
        content_name: itemTitle || '',
        content_ids: [itemId || ''],
        value: itemPrice || 0,
        currency: S.currency || 'ARS',
        num_items: qty || 1
      });
    }
  }

  function fireInitiateCheckoutPixel(value, currency) {
    if (window.fbq) {
      fbq('track', 'InitiateCheckout', {
        value: value || 0,
        currency: currency || 'ARS',
        num_items: 1
      });
    }
  }

  /* ==================
     STICKY MOBILE BAR
     ================== */
  function initStickyBar() {
    var bar = document.getElementById('cart-sticky-bar'); if (!bar) return;
    var sidebar = document.querySelector('.cart-sidebar');
    if (!sidebar) return;
    var observer = new IntersectionObserver(function(entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.1 });
    observer.observe(sidebar);
  }

  /* Sticky "Agregar al carrito" bar on the product page (mobile) */
  function initProductStickyBar() {
    var bar = document.getElementById('product-sticky-bar'); if (!bar) return;
    var anchor = document.getElementById('add-to-cart-btn') || document.getElementById('request-quote-btn');
    if (!anchor) return;
    // Move out of any transformed ancestor (e.g. .fade-up) so position:fixed anchors to the viewport
    document.body.appendChild(bar);

    var form = document.getElementById('product-form');
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var stickyQty = document.getElementById('sticky-qty');
    var stickyPrice = document.getElementById('sticky-price');

    function updateSticky() {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (stickyQty) stickyQty.textContent = qty;
      var unit = parseInt(bar.getAttribute('data-unit-price'), 10) || 0;
      if (stickyPrice && unit) stickyPrice.textContent = formatMoney(unit * qty);
    }

    // The sticky qty stepper drives the form's quantity input (single source of truth)
    bar.addEventListener('click', function(e) {
      var b = e.target.closest('[data-sticky-qty]'); if (!b || !qtyInput) return;
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = b.getAttribute('data-sticky-qty') === 'increase' ? v + 1 : Math.max(1, v - 1);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', updateSticky);
      qtyInput.addEventListener('input', updateSticky);
    }
    updateSticky();

    var observer = new IntersectionObserver(function(entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-product-sticky', show);
    }, { threshold: 0 });
    observer.observe(anchor);
  }

  /* Product gift-message note: collapse to a chip on blur, edit on tap (like the cart note) */
  function initProductNote() {
    var wrap = document.getElementById('bouquet-note'); if (!wrap) return;
    var addBtn = document.getElementById('bouquet-note-add');
    var field = wrap.querySelector('.bouquet-note__field');
    var ta = wrap.querySelector('textarea');
    var display = wrap.querySelector('.bouquet-note__display');
    var displayText = wrap.querySelector('.bouquet-note__display-text');
    var editBtn = wrap.querySelector('.bouquet-note__edit');
    if (!addBtn || !field || !ta || !display) return;

    function showField() { addBtn.hidden = true; display.hidden = true; field.hidden = false; ta.focus(); }
    function showAdd() { field.hidden = true; display.hidden = true; addBtn.hidden = false; }
    function showDisplay() { displayText.textContent = ta.value; field.hidden = true; addBtn.hidden = true; display.hidden = false; }

    addBtn.addEventListener('click', showField);
    if (editBtn) editBtn.addEventListener('click', showField);
    ta.addEventListener('blur', function() {
      if (ta.value.trim()) showDisplay();
      else { ta.value = ''; showAdd(); }
    });
  }

  /* Faceted filters on collection pages (scoped to each [data-facets] sidebar) */
  function initFacets() {
    document.querySelectorAll('[data-facets]').forEach(function(root) {
      var toggle = root.querySelector('.search-sidebar__toggle');
      if (toggle) toggle.addEventListener('click', function() {
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
      });
      var sliderMin = root.querySelector('.js-price-min');
      var sliderMax = root.querySelector('.js-price-max');
      var inputMin = root.querySelector('.js-price-input-min');
      var inputMax = root.querySelector('.js-price-input-max');
      var sliderRange = root.querySelector('.js-price-range');
      if (!sliderMin || !sliderMax) return;
      function updateSlider(e) {
        var min = parseInt(sliderMin.value, 10);
        var max = parseInt(sliderMax.value, 10);
        var rangeMin = parseInt(sliderMin.min, 10);
        var rangeMax = parseInt(sliderMin.max, 10);
        var total = rangeMax - rangeMin;
        if (min > max - 1) {
          if (e && e.target === sliderMin) sliderMin.value = max - 1; else sliderMax.value = min + 1;
          min = parseInt(sliderMin.value, 10); max = parseInt(sliderMax.value, 10);
        }
        if (inputMin) inputMin.value = min > rangeMin ? min : '';
        if (inputMax) inputMax.value = max < rangeMax ? max : '';
        if (sliderRange && total > 0) {
          sliderRange.style.left = ((min - rangeMin) / total * 100) + '%';
          sliderRange.style.right = (100 - (max - rangeMin) / total * 100) + '%';
        }
      }
      sliderMin.addEventListener('input', updateSlider);
      sliderMax.addEventListener('input', updateSlider);
      if (inputMin) inputMin.addEventListener('change', function() {
        var v = parseInt(this.value, 10);
        sliderMin.value = isNaN(v) ? sliderMin.min : v; updateSlider();
      });
      if (inputMax) inputMax.addEventListener('change', function() {
        var v = parseInt(this.value, 10);
        sliderMax.value = isNaN(v) ? sliderMax.max : v; updateSlider();
      });
      updateSlider();
    });
  }

  /* Collection pages: filter / sort / paginate via AJAX (no full reload) */
  function initCollectionAjax() {
    if (!document.body.classList.contains('template-collection')) return;
    var section = document.getElementById('products-grid');
    if (!section) return;

    // Viewport-centered spinner (appended to body so it isn't affected by transformed ancestors)
    var spinner = document.querySelector('.ajax-spinner');
    if (!spinner) { spinner = document.createElement('div'); spinner.className = 'ajax-spinner'; document.body.appendChild(spinner); }

    function formUrl(form) {
      var clean = new URLSearchParams();
      new FormData(form).forEach(function(v, k) {
        if (v !== '' && v != null) clean.append(k, v);
      });
      var qs = clean.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }

    function loadUrl(url, push) {
      var wasOpen = !!section.querySelector('.search-sidebar.is-open');
      section.classList.add('is-loading-facets');
      if (spinner) spinner.classList.add('is-active');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('products-grid');
          if (fresh) section.innerHTML = fresh.innerHTML;
          if (push) history.pushState({ facets: true }, '', url);
          initFacets();
          if (wasOpen) {
            var sb = section.querySelector('.search-sidebar');
            if (sb) { sb.classList.add('is-open'); var t = sb.querySelector('.search-sidebar__toggle'); if (t) t.setAttribute('aria-expanded', 'true'); }
          } else {
            var top = section.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
          section.classList.remove('is-loading-facets');
          if (spinner) spinner.classList.remove('is-active');
        })
        .catch(function() { window.location.href = url; });
    }

    section.addEventListener('change', function(e) {
      var cb = e.target.closest('[data-facets] input[type="checkbox"]');
      if (cb && cb.form) { loadUrl(formUrl(cb.form), true); return; }
      var sort = e.target.closest('#sort-by');
      if (sort) {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sort.value);
        loadUrl(u.pathname + u.search, true);
      }
    });

    section.addEventListener('submit', function(e) {
      var form = e.target.closest('.search-sidebar__form');
      if (form) { e.preventDefault(); loadUrl(formUrl(form), true); }
    });

    section.addEventListener('click', function(e) {
      var a = e.target.closest('.collection-pager a, .search-filter__active a');
      if (a && a.getAttribute('href')) { e.preventDefault(); loadUrl(a.getAttribute('href'), true); }
    });

    window.addEventListener('popstate', function() {
      loadUrl(location.pathname + location.search, false);
    });
  }

  /* Product page: dynamic "Se entrega hoy / Reservá para…" based on store fabrication hours */
  function initEntregaHoyMessage() {
    var textEl = document.getElementById('entrega-hoy-text'); if (!textEl) return;
    var cfg = window.YomikoeStoreHours; if (!cfg) return;
    var now = ykStoreNow();
    if (isNaN(now.getTime())) now = new Date();
    var dow = now.getDay();
    var nowMin = now.getHours() * 60 + now.getMinutes();

    var todayCut = ykFabCutoff(dow);
    if (todayCut !== null && nowMin < todayCut) return; // still on time for today → keep default message

    var dayNames = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    for (var i = 1; i <= 7; i++) {
      var d = (dow + i) % 7;
      if (ykFabCutoff(d) !== null) {
        var label = i === 1 ? 'mañana' : 'el ' + dayNames[d];
        var tmpl = cfg.msgNext || '📅 Reservá tu entrega para {dia}';
        textEl.textContent = tmpl.replace('{dia}', label);
        return;
      }
    }
  }

  /* ==================
     HERO SLIDESHOW (slide animation, arrows, drag, swipe, seamless loop)
     ================== */
  function initSlideshow() {
    var el = document.querySelector('.hero-slideshow'); if (!el) return;
    var track = el.querySelector('.hero-slideshow__track');
    var slides = el.querySelectorAll('.hero-slide');
    var dots = el.querySelectorAll('.hero-dot');
    var prevBtn = el.querySelector('.hero-arrow--prev');
    var nextBtn = el.querySelector('.hero-arrow--next');
    if (!track || slides.length <= 1) return;

    var total = slides.length;

    // Clone first slide at the end for seamless forward loop
    var clone = slides[0].cloneNode(true);
    clone.removeAttribute('data-block-id');
    track.appendChild(clone);

    var cur = 0, iv, slideWidth;
    var isDragging = false, startX = 0, prevTranslate = 0;

    function getSlideWidth() { return el.offsetWidth; }

    function setTrack(animate) {
      track.style.transition = animate ? 'transform .7s cubic-bezier(.25,.1,.25,1)' : 'none';
      track.style.transform = 'translateX(' + (-cur * slideWidth) + 'px)';
    }

    function goTo(n, instant) {
      cur = n;
      slideWidth = getSlideWidth();
      setTrack(!instant);
      dots.forEach(function(d, i) { d.classList.toggle('active', i === (cur % total)); });
    }

    function next() { goTo(cur + 1); }
    function prev() {
      if (cur === 0) {
        // Jump to clone of last slide instantly, then animate to real last slide
        goTo(total, true);
        track.offsetHeight; // force reflow
        goTo(total - 1);
      } else {
        goTo(cur - 1);
      }
    }

    // After transition, if on the clone (slide total), silently jump back to slide 0
    track.addEventListener('transitionend', function() {
      if (cur >= total) {
        goTo(0, true);
      }
    });

    function startAutoplay() { iv = setInterval(next, (parseInt(el.dataset.speed) || 5000)); }
    function restartAutoplay() { clearInterval(iv); startAutoplay(); }

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener('click', function() { restartAutoplay(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { restartAutoplay(); next(); });

    // Dots
    dots.forEach(function(d, i) { d.addEventListener('click', function() { restartAutoplay(); goTo(i); }); });

    // Touch swipe (mobile)
    var touchStartX = 0;
    el.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      isDragging = true;
      startX = e.changedTouches[0].clientX;
      slideWidth = getSlideWidth();
      prevTranslate = -cur * slideWidth;
    }, { passive: true });

    el.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var currentX = e.changedTouches[0].clientX;
      var currentTranslate = prevTranslate + (currentX - startX);
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
    }, { passive: true });

    el.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';
      var touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        restartAutoplay();
        diff > 0 ? next() : prev();
      } else {
        goTo(cur);
      }
    }, { passive: true });

    // Desktop mouse drag
    var mouseDown = false, mouseStartX = 0, mousePrevTranslate = 0;
    el.addEventListener('mousedown', function(e) {
      if (e.target.closest('a, button')) return;
      e.preventDefault();
      mouseDown = true;
      mouseStartX = e.clientX;
      slideWidth = getSlideWidth();
      mousePrevTranslate = -cur * slideWidth;
      el.style.cursor = 'grabbing';
    });

    el.addEventListener('mousemove', function(e) {
      if (!mouseDown) return;
      e.preventDefault();
      var currentX = e.clientX;
      var mouseCurrentTranslate = mousePrevTranslate + (currentX - mouseStartX);
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + mouseCurrentTranslate + 'px)';
    });

    el.addEventListener('mouseup', function(e) {
      if (!mouseDown) return;
      mouseDown = false;
      el.style.cursor = '';
      track.style.transition = '';
      var movedBy = e.clientX - mouseStartX;
      if (Math.abs(movedBy) > 60) {
        restartAutoplay();
        movedBy < 0 ? next() : prev();
      } else {
        goTo(cur);
      }
    });

    el.addEventListener('mouseleave', function() {
      if (!mouseDown) return;
      mouseDown = false;
      el.style.cursor = '';
      track.style.transition = '';
      goTo(cur);
    });

    // Handle resize — recalculate positions
    window.addEventListener('resize', function() {
      goTo(cur, true);
    });

    // Initialize
    goTo(0, true);
    startAutoplay();
  }

  /* ==================
     MEGA MENU
     ================== */
  function initMegaMenu() {
    var triggers = document.querySelectorAll('[data-mega-trigger]');
    var overlay = document.getElementById('mega-menu-overlay');
    var openMenu = null;
    var closeTimer = null;

    function resetMegaTabs(menu) {
      var tabs = menu.querySelectorAll('.mega-menu__sidebar-tab');
      var panels = menu.querySelectorAll('.mega-menu__panel');
      tabs.forEach(function(t) { t.classList.remove('is-active'); });
      panels.forEach(function(p) { p.classList.remove('is-active'); });
      if (tabs[0]) tabs[0].classList.add('is-active');
      if (panels[0]) panels[0].classList.add('is-active');
      // Reset featured previews to default (first item)
      panels.forEach(function(panel) {
        var preview = panel.querySelector('[data-mega-preview]');
        if (!preview) return;
        var firstItem = panel.querySelector('.mega-menu__panel-item[data-preview-img]');
        if (firstItem) updatePreview(preview, firstItem);
      });
    }

    function openMega(menuId) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openMenu && openMenu !== menuId) closeMega();
      var menu = document.getElementById('mega-menu-' + menuId);
      var trigger = document.querySelector('[data-mega-trigger="' + menuId + '"]');
      if (!menu) return;
      resetMegaTabs(menu);
      menu.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-visible');
      openMenu = menuId;
    }

    function closeMega() {
      if (!openMenu) return;
      var menu = document.getElementById('mega-menu-' + openMenu);
      var trigger = document.querySelector('[data-mega-trigger="' + openMenu + '"]');
      if (menu) menu.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-visible');
      openMenu = null;
    }

    function scheduleClose() {
      closeTimer = setTimeout(function() { closeMega(); }, 200);
    }

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    triggers.forEach(function(trigger) {
      var menuId = trigger.getAttribute('data-mega-trigger');
      var menu = document.getElementById('mega-menu-' + menuId);

      trigger.addEventListener('mouseenter', function() { openMega(menuId); });
      trigger.addEventListener('mouseleave', function() { scheduleClose(); });
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (openMenu === menuId) { closeMega(); } else { openMega(menuId); }
      });

      if (menu) {
        menu.addEventListener('mouseenter', function() { cancelClose(); });
        menu.addEventListener('mouseleave', function() { scheduleClose(); });
      }
    });

    if (overlay) overlay.addEventListener('click', function() { closeMega(); });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMega();
    });

    // Update featured preview card
    function updatePreview(previewEl, itemEl) {
      var img = previewEl.querySelector('[data-preview-el="img"]');
      var title = previewEl.querySelector('[data-preview-el="title"]');
      var desc = previewEl.querySelector('[data-preview-el="desc"]');
      var cta = previewEl.querySelector('[data-preview-el="cta"]');
      var ctaTitle = previewEl.querySelector('[data-preview-el="cta-title"]');

      var newImg = itemEl.getAttribute('data-preview-img');
      var newTitle = itemEl.getAttribute('data-preview-title');
      var newDesc = itemEl.getAttribute('data-preview-desc');
      var newUrl = itemEl.getAttribute('data-preview-url');

      // Fade out, swap, fade in
      previewEl.classList.remove('is-preview-visible');
      setTimeout(function() {
        if (img) {
          if (newImg) { img.src = newImg; img.alt = newTitle; img.style.display = ''; }
          else { img.style.display = 'none'; }
        }
        if (title) title.textContent = newTitle;
        if (desc) desc.textContent = newDesc || '';
        if (cta) cta.href = newUrl || '#';
        if (ctaTitle) ctaTitle.textContent = (newTitle || '').toUpperCase();
        previewEl.classList.add('is-preview-visible');
      }, 120);
    }

    // Tab switching inside mega menu
    document.querySelectorAll('[data-mega-tab]').forEach(function(tab) {
      tab.addEventListener('mouseenter', function() {
        var panelId = tab.getAttribute('data-mega-tab');
        var megaMenu = tab.closest('.mega-menu');
        if (!megaMenu) return;

        megaMenu.querySelectorAll('.mega-menu__sidebar-tab').forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        megaMenu.querySelectorAll('.mega-menu__panel').forEach(function(p) { p.classList.remove('is-active'); });
        var panel = document.getElementById('mega-panel-' + panelId);
        if (panel) {
          panel.classList.add('is-active');
          // Reset preview to first item
          var preview = panel.querySelector('[data-mega-preview]');
          var firstItem = panel.querySelector('.mega-menu__panel-item[data-preview-img]');
          if (preview && firstItem) updatePreview(preview, firstItem);
        }
      });
    });

    // Hover on panel items updates featured preview
    document.querySelectorAll('.mega-menu__panel-item[data-preview-img]').forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        var panel = item.closest('.mega-menu__panel');
        if (!panel) return;
        var preview = panel.querySelector('[data-mega-preview]');
        if (preview) updatePreview(preview, item);
      });
    });

    // Close mega menu when clicking sidebar links
    document.querySelectorAll('.mega-menu__sidebar-link, .mega-menu__panel-item, .mega-menu__featured-cta').forEach(function(link) {
      link.addEventListener('click', function() { closeMega(); });
    });
  }

  /* ==================
     MOBILE MENU (drawer)
     ================== */
  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var drawer = document.getElementById('mobile-nav-drawer');
    var overlay = document.getElementById('mobile-nav-overlay');
    var closeBtn = drawer ? drawer.querySelector('.mobile-nav-drawer__close') : null;

    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Handle ALL mobile dropdown toggles (including nested), use event delegation
    drawer.addEventListener('click', function(e) {
      var btn = e.target.closest('.mobile-dropdown-toggle');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var dd = btn.parentElement.querySelector('.mobile-dropdown');
      if (dd) { dd.classList.toggle('is-open'); btn.textContent = dd.classList.contains('is-open') ? '\u2212' : '+'; }
    });

    // Handle mobile parent links with children (toggle instead of navigate)
    drawer.addEventListener('click', function(e) {
      var link = e.target.closest('.mobile-nav__link-mobile[data-has-children]');
      if (!link) return;
      e.preventDefault(); e.stopPropagation();
      var dd = link.parentElement.querySelector('.mobile-dropdown');
      if (dd) { dd.classList.toggle('is-open'); var toggleBtn = link.parentElement.querySelector('.mobile-dropdown-toggle'); if (toggleBtn) toggleBtn.textContent = dd.classList.contains('is-open') ? '\u2212' : '+'; }
    });
  }

  /* ==================
     MARQUEE ANNOUNCEMENT BAR
     ================== */
  function initMarquee() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var track = bar.querySelector('.announcement-track');
    if (!track) return;

    var speed = parseInt(bar.dataset.speed) || 20;
    track.style.setProperty('--marquee-duration', speed + 's');

    var loops = parseInt(track.dataset.loops) || 5;
    var loopCount = 0;

    track.addEventListener('animationiteration', function() {
      loopCount++;
      if (loopCount >= loops) {
        track.classList.add('is-paused');
        setTimeout(function() {
          loopCount = 0;
          track.classList.remove('is-paused');
        }, 3000);
      }
    });
  }

  /* ==================
     CAROUSEL ARROWS + INFINITE LOOP
     Adds prev/next arrow buttons and infinite scroll to product carousels
     Layout: [pre-clones] [originals] [post-clones] — seamless bidirectional loop
     ================== */
  var carouselArrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  var carouselArrowSvgNext = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  function initCarouselArrows() {
    var selectors = '.product-scroll-row, .recommend-popup__products';
    document.querySelectorAll(selectors).forEach(function(row) {
      if (row.closest('.carousel-wrapper')) return;

      // Wrap the scroll row in a carousel-wrapper
      var wrapper = document.createElement('div');
      wrapper.className = 'carousel-wrapper';
      row.parentNode.insertBefore(wrapper, row);
      wrapper.appendChild(row);

      // Create arrow buttons
      var prevBtn = document.createElement('button');
      prevBtn.className = 'carousel-arrow carousel-arrow--prev';
      prevBtn.setAttribute('aria-label', 'Anterior');
      prevBtn.innerHTML = carouselArrowSvg;

      var nextBtn = document.createElement('button');
      nextBtn.className = 'carousel-arrow carousel-arrow--next';
      nextBtn.setAttribute('aria-label', 'Siguiente');
      nextBtn.innerHTML = carouselArrowSvgNext;

      wrapper.insertBefore(prevBtn, row);
      wrapper.appendChild(nextBtn);

      // Build infinite loop: [pre-clones x2] [originals] [post-clones x2]
      // 2x clones give enough buffer so the debounce reset never reaches the scroll boundary
      var children = Array.prototype.slice.call(row.children);
      if (children.length) {
        // Append post-clones (2 copies)
        for (var copy = 0; copy < 2; copy++) {
          children.forEach(function(child) {
            var clone = child.cloneNode(true);
            clone.setAttribute('data-carousel-clone', 'after');
            row.appendChild(clone);
          });
        }
        // Prepend pre-clones (2 copies, inserted in reverse to keep order)
        for (var copy = 0; copy < 2; copy++) {
          for (var i = children.length - 1; i >= 0; i--) {
            var clone = children[i].cloneNode(true);
            clone.setAttribute('data-carousel-clone', 'before');
            row.insertBefore(clone, row.firstChild);
          }
        }
      }

      // Calculate the offset where originals start (= width of pre-clones zone)
      // Use the first non-clone element's offsetLeft for precision
      var firstOriginal = row.querySelector(':not([data-carousel-clone])');
      var originalStart = firstOriginal ? firstOriginal.offsetLeft : 0;
      // Width of the original zone
      var originals = Array.prototype.filter.call(row.children, function(c) {
        return !c.hasAttribute('data-carousel-clone');
      });
      var lastOriginal = originals.length ? originals[originals.length - 1] : null;
      var originalWidth = lastOriginal
        ? (lastOriginal.offsetLeft + lastOriginal.offsetWidth - originalStart)
        : 0;

      // Start scroll at the beginning of originals
      if (originalStart) {
        row.scrollLeft = originalStart;
      }

      // Arrow click handlers — use smooth scroll
      function getScrollAmount() {
        var card = row.querySelector('.product-card, .recommend-card');
        return card ? card.offsetWidth + parseInt(getComputedStyle(row).gap || 0) : 260;
      }

      prevBtn.addEventListener('click', function() {
        if (!originalWidth) return;
        row.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function() {
        if (!originalWidth) return;
        row.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      // Track whether user is actively interacting (skip reset during drag/touch)
      var isTouching = false;
      row.addEventListener('touchstart', function() { isTouching = true; }, { passive: true });
      row.addEventListener('touchend', function() {
        // Delay clearing so the scroll handler doesn't reset during momentum
        setTimeout(function() { isTouching = false; }, 500);
      });

      // Infinite loop: silently reposition when scrolling into clone zones
      // Only after scroll has fully stopped (respect momentum)
      var scrollTimer;
      var isRepositioning = false;
      var CLONE_TOLERANCE = 5; // px margin to prevent boundary jitter
      row.addEventListener('scroll', function() {
        if (!originalWidth) return;
        // Always clear pending timer, even during repositioning, to prevent stale callbacks
        clearTimeout(scrollTimer);
        if (isRepositioning) return;
        scrollTimer = setTimeout(function() {
          if (isTouching) return;
          var sl = row.scrollLeft;
          // Entered post-clone zone on the right → jump back
          if (sl >= originalStart + originalWidth + CLONE_TOLERANCE) {
            isRepositioning = true;
            row.scrollLeft = sl - originalWidth;
            setTimeout(function() { isRepositioning = false; }, 400);
          }
          // Entered pre-clone zone on the left → jump forward
          else if (sl < originalStart - CLONE_TOLERANCE) {
            isRepositioning = true;
            row.scrollLeft = sl + originalWidth;
            setTimeout(function() { isRepositioning = false; }, 400);
          }
        }, 350);
      });

      // MutationObserver: re-clone when children actually change (not from clone manipulation)
      var isCloning = false;
      var observer = new MutationObserver(function(mutations) {
        if (isCloning) return;
        // Only react when non-clone children are added/removed
        var hasRealChange = mutations.some(function(m) {
          return Array.prototype.some.call(m.addedNodes, function(n) {
            return n.nodeType === 1 && !n.hasAttribute('data-carousel-clone');
          }) || Array.prototype.some.call(m.removedNodes, function(n) {
            return n.nodeType === 1 && !n.hasAttribute('data-carousel-clone');
          });
        });
        if (!hasRealChange) return;
        isCloning = true;
        // Remember scroll offset relative to originals to avoid visible jump
        var savedOffset = row.scrollLeft - originalStart;
        // Remove all existing clones
        row.querySelectorAll('[data-carousel-clone]').forEach(function(c) { c.remove(); });
        // Capture original children (all that remain after clone removal)
        var currentChildren = Array.prototype.filter.call(row.children, function(c) {
          return !c.hasAttribute('data-carousel-clone');
        });
        if (currentChildren.length) {
          // Append post-clones (2 copies)
          for (var copy = 0; copy < 2; copy++) {
            currentChildren.forEach(function(child) {
              var clone = child.cloneNode(true);
              clone.setAttribute('data-carousel-clone', 'after');
              row.appendChild(clone);
            });
          }
          // Prepend pre-clones (2 copies)
          for (var copy = 0; copy < 2; copy++) {
            for (var i = currentChildren.length - 1; i >= 0; i--) {
              var clone = currentChildren[i].cloneNode(true);
              clone.setAttribute('data-carousel-clone', 'before');
              row.insertBefore(clone, row.firstChild);
            }
          }
        }
        // Recalculate and restore scroll position without visible jump
        setTimeout(function() {
          var fo = row.querySelector(':not([data-carousel-clone])');
          originalStart = fo ? fo.offsetLeft : 0;
          var origs = Array.prototype.filter.call(row.children, function(c) {
            return !c.hasAttribute('data-carousel-clone');
          });
          var lo = origs.length ? origs[origs.length - 1] : null;
          originalWidth = lo ? (lo.offsetLeft + lo.offsetWidth - originalStart) : 0;
          // Restore position relative to originals instead of resetting to 0
          if (originalStart) {
            row.scrollLeft = originalStart + Math.max(0, Math.min(savedOffset, originalWidth - row.offsetWidth));
          }
          isCloning = false;
        }, 60);
      });
      observer.observe(row, { childList: true });

      // Recalculate positions on resize / image load to keep infinite loop accurate
      function recalcPositions() {
        var fo = row.querySelector(':not([data-carousel-clone])');
        var newStart = fo ? fo.offsetLeft : 0;
        var origs = Array.prototype.filter.call(row.children, function(c) {
          return !c.hasAttribute('data-carousel-clone');
        });
        var lo = origs.length ? origs[origs.length - 1] : null;
        var newWidth = lo ? (lo.offsetLeft + lo.offsetWidth - newStart) : 0;
        if (newWidth) {
          originalStart = newStart;
          originalWidth = newWidth;
        }
      }
      window.addEventListener('resize', function() {
        requestAnimationFrame(recalcPositions);
      });
      // Recalculate after lazy images finish loading (they can change card dimensions)
      row.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
        if (!img.complete) {
          img.addEventListener('load', function() {
            setTimeout(recalcPositions, 50);
          });
        }
      });
    });
  }

  /* ==================
     MOUSE DRAG FOR SCROLL ROWS (desktop only)
     Mobile uses native overflow-x scroll with -webkit-overflow-scrolling: touch
     ================== */
  function initScrollRowSwipe() {
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) return;

    document.querySelectorAll('.product-scroll-row, .testimonials-scroll, .recommend-popup__products').forEach(function(row) {
      var isDown = false, startX, scrollLeft, moved = false;

      row.addEventListener('mousedown', function(e) {
        if (e.target.closest('button')) return;
        e.preventDefault(); // prevent text selection during drag
        isDown = true; moved = false;
        row.classList.add('is-dragging');
        startX = e.pageX - row.offsetLeft;
        scrollLeft = row.scrollLeft;
      });
      row.addEventListener('mouseleave', function() { isDown = false; row.classList.remove('is-dragging'); });
      row.addEventListener('mouseup', function() { isDown = false; row.classList.remove('is-dragging'); });
      row.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        moved = true;
        var x = e.pageX - row.offsetLeft;
        row.scrollLeft = scrollLeft - (x - startX);
      });
      row.addEventListener('click', function(e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ==================
     UI INITS
     ================== */
  function initQuantityButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.qty-btn'); if (!btn) return;
      var wrap = btn.closest('.qty-wrap') || btn.closest('.product-form__quantity') || btn.closest('.variant-popup__qty'); if (!wrap) return;
      var input = wrap.querySelector('.qty-input'); if (!input) return;
      var v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease' && v > 1) input.value = v - 1;
      else if (btn.dataset.action === 'increase') input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-gallery__thumb'), mainImg = document.getElementById('product-main-image');
    var galleryMain = document.getElementById('product-gallery-main');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function(t) { 
      t.addEventListener('click', function() { 
        thumbs.forEach(function(x) { x.classList.remove('active'); }); 
        t.classList.add('active'); 
        
        // Add loading state before changing image
        mainImg.classList.remove('is-loaded');
        mainImg.classList.add('is-loading');
        if (galleryMain) galleryMain.classList.remove('is-loaded');
        
        var newSrc = t.dataset.fullSrc || t.querySelector('img').src;
        
        // Handle image load
        mainImg.onload = function() {
          mainImg.classList.remove('is-loading');
          mainImg.classList.add('is-loaded');
          if (galleryMain) galleryMain.classList.add('is-loaded');
        };
        
        mainImg.src = newSrc;
      }); 
    });
  }
  
  /* ==================
     PRODUCT VARIANT SELECTION
     - Separate dropdowns for each option
     - Updates price and image on selection change
     ================== */
  function initProductVariants() {
    var variantsJson = document.getElementById('product-variants-json');
    if (!variantsJson) return;
    
    var variants;
    try { 
      variants = JSON.parse(variantsJson.textContent); 
    } catch(e) { 
      console.error('Error parsing variant JSON:', e);
      return; 
    }
    
    var optionSelects = document.querySelectorAll('.product-option-select');
    var variantIdInput = document.getElementById('variant-id');
    var currentPriceEl = document.getElementById('current-price');
    var comparePriceEl = document.getElementById('compare-price');
    var mainImage = document.getElementById('product-main-image');
    var addToCartBtn = document.getElementById('add-to-cart-btn');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    
    if (!optionSelects.length || !variants.length) return;
    
    function formatMoney(cents) {
      return '$' + (cents / 100).toLocaleString(S.locale || 'es', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    
    function getSelectedOptions() {
      var options = [];
      optionSelects.forEach(function(select) {
        var index = parseInt(select.dataset.optionIndex);
        options[index] = select.value;
      });
      return options;
    }
    
    function findVariant(options) {
      return variants.find(function(v) {
        if (!v.options || v.options.length !== options.length) return false;
        return v.options.every(function(opt, i) {
          return opt === options[i];
        });
      });
    }
    
    function updateVariant() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      
      if (!variant) {
        // No matching variant - disable add to cart
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = S.unavailable || 'No disponible';
        }
        var sbNone = document.getElementById('product-sticky-bar');
        if (sbNone) {
          var ctaNone = sbNone.querySelector('.product-sticky-bar__cta');
          if (ctaNone) { ctaNone.disabled = true; ctaNone.textContent = S.unavailable || 'No disponible'; }
        }
        return;
      }
      
      // Update variant ID
      if (variantIdInput) variantIdInput.value = variant.id;
      
      // Update price
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(variant.price);
      
      // Update compare price
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      
      // Update add to cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = S.addToCart || 'Agregar al carrito';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = S.soldOut || 'Agotado';
        }
      }

      // Keep the sticky bar in sync with the selected variant (unit price + CTA state)
      var sb = document.getElementById('product-sticky-bar');
      if (sb) {
        sb.setAttribute('data-unit-price', variant.price);
        var scta = sb.querySelector('.product-sticky-bar__cta');
        if (scta) {
          scta.disabled = !variant.available;
          scta.textContent = variant.available ? (S.addToCart || 'Agregar al carrito') : (S.soldOut || 'Agotado');
        }
        var qi = document.querySelector('#product-form input[name="quantity"]');
        if (qi) qi.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Update image if variant has a featured image
      if (variant.featured_image_url && mainImage) {
        // Add loading state before changing image
        mainImage.classList.remove('is-loaded');
        mainImage.classList.add('is-loading');
        var galleryMain = document.getElementById('product-gallery-main');
        if (galleryMain) galleryMain.classList.remove('is-loaded');
        
        mainImage.onload = function() {
          mainImage.classList.remove('is-loading');
          mainImage.classList.add('is-loaded');
          if (galleryMain) galleryMain.classList.add('is-loaded');
        };
        
        mainImage.src = variant.featured_image_url;
        
        // Update thumbnail active state
        if (variant.featured_image_id) {
          thumbs.forEach(function(thumb) {
            var imageId = parseInt(thumb.dataset.imageId);
            if (imageId === variant.featured_image_id) {
              thumb.classList.add('active');
            } else {
              thumb.classList.remove('active');
            }
          });
        }
      }
    }
    
    // Listen to option changes
    optionSelects.forEach(function(select) {
      select.addEventListener('change', updateVariant);
    });
    
    // Initial update on page load
    updateVariant();
  }
  function initLanguageSelector() { document.querySelectorAll('.locale-selector').forEach(function(s) { s.addEventListener('change', function() { if (this.value) window.location.href = this.value; }); }); }
  function initMaxLength() { initMaxLengthIn(document); }
  function initMaxLengthIn(root) {
    root.querySelectorAll('textarea[maxlength]').forEach(function(ta) {
      if (ta.nextElementSibling && ta.nextElementSibling.classList.contains('char-counter')) return;
      var max = parseInt(ta.getAttribute('maxlength')); if (!max) return;
      var counter = document.createElement('small'); counter.className = 'char-counter'; counter.textContent = ta.value.length + '/' + max;
      ta.parentNode.insertBefore(counter, ta.nextSibling);
      ta.addEventListener('input', function() { if (ta.value.length > max) ta.value = ta.value.substring(0, max); counter.textContent = ta.value.length + '/' + max; });
    });
  }

  /* ==================
     HEADER SCROLL BEHAVIOR
     - Header is fixed, overlays hero
     - Announcement bar collapses on scroll (mobile: 10px, desktop: 50px)
     - Header goes solid after scrolling past hero, transparent at top
     - Hover triggers solid background
     ================== */
  function initHeaderScroll() {
    var announcement = document.querySelector('.announcement-section');
    var header = document.querySelector('.site-header');
    if (!header) return;

    // If the announcement bar is hidden via CSS (e.g. on cart page), treat it as absent
    if (announcement && getComputedStyle(announcement).display === 'none') {
      announcement = null;
      header.style.top = '0';
    }

    var hero = document.querySelector('.hero-slideshow') || document.querySelector('.hero-section') || document.querySelector('.landing-hero');
    var isMobile = window.innerWidth < 1024;
    var collapseThreshold = isMobile ? 10 : 50;
    var ticking = false;
    var announcementHeight = announcement ? 28 : 0;

    // Add body class if there's a hero on the page (for proper spacing)
    // Collection hero also counts as a hero for header overlay
    var collectionHero = document.querySelector('.collection-hero');
    var hasHeroSection = hero || collectionHero;
    
    if (hasHeroSection) {
      document.body.classList.add('has-hero');
    } else {
      document.body.classList.add('no-hero');
      // Header should be solid from the start on pages without hero
      header.classList.add('is-solid');
      // Add padding to body for non-hero pages to prevent content being hidden behind fixed header
      function updateBodyPadding() {
        var headerHeight = header.offsetHeight;
        var annHeight = announcement && !announcement.classList.contains('is-collapsed') ? announcement.offsetHeight : 0;
        document.body.style.paddingTop = (headerHeight + annHeight) + 'px';
      }
      updateBodyPadding();
      window.addEventListener('resize', function() {
        if (!ticking) {
          requestAnimationFrame(updateBodyPadding);
          ticking = true;
        }
      });
    }

    function getHeroHeight() {
      if (!hero) return 0;
      return hero.offsetHeight;
    }
    
    function getCollectionHeroHeight() {
      var collectionHero = document.querySelector('.collection-hero');
      if (!collectionHero) return 0;
      return collectionHero.offsetHeight;
    }

    function onScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      var heroHeight = getHeroHeight();
      var collectionHeroHeight = getCollectionHeroHeight();
      var headerHeight = header.offsetHeight;

      if (announcement) {
        if (scrollY > collapseThreshold) {
          announcement.classList.add('is-collapsed');
          // Adjust header position when announcement collapses
          header.style.top = '0';
        } else {
          announcement.classList.remove('is-collapsed');
          // Reset header position when announcement is visible
          header.style.top = announcementHeight + 'px';
        }
      }

      // Solid header when scrolled past hero or collection hero (minus header height to transition earlier)
      var solidThreshold = Math.max(heroHeight, collectionHeroHeight) - headerHeight - 50;
      if (scrollY > Math.max(solidThreshold, 80) || document.body.classList.contains('no-hero')) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }

      ticking = false;
    }

    // Set initial header position
    if (announcement) {
      header.style.top = announcementHeight + 'px';
    }

    window.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });

    window.addEventListener('resize', function() {
      isMobile = window.innerWidth < 1024;
      collapseThreshold = isMobile ? 10 : 50;
    });

    onScroll();
  }

  /* ==================
     INIT
     ================== */
  document.addEventListener('DOMContentLoaded', function() {
    initSlideshow(); initMobileMenu(); initMarquee(); initHeaderScroll();
    initQuantityButtons(); initProductGallery(); initProductVariants();
    initNotificationClose(); initVariantPopup(); initQuickAdd(); initAddToCartForm(); initRequestQuote();
    initCartUpdates(); initDeliveryPicker(); initWhatsAppTransfer(); initCartDrawer();
    initLanguageSelector(); initMaxLength(); initStickyBar(); initProductStickyBar(); initProductNote(); initEntregaHoyMessage(); initWhatsAppPopup();
    initScrollRowSwipe(); initCarouselArrows(); initSeasonPopup(); initCollectionCTA();
    initRecommendPopup(); interceptPayButtons(); initFacets(); initCollectionAjax();
    initMegaMenu();
    initWhatsAppLinkTracking();
    initInstagramLinkTracking();
    initMetaPixelPageEvents();
    
    // Animate cart items on initial page load
    animateCartItemsOnLoad();
    
    // Initialize product image loading animation
    initProductImageLoading();
  });
  
  // Season popup for out-of-season collections
  function initSeasonPopup() {
    var overlay = document.getElementById('season-popup-overlay');
    var closeBtn = document.getElementById('season-popup-close');
    if (!overlay) return;
    
    // Show popup after a short delay
    setTimeout(function() {
      overlay.classList.add('is-visible');
    }, 300);
    
    // Close on X button
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        overlay.classList.remove('is-visible');
      });
    }
    
    // Close on overlay click (outside popup)
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-visible');
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        overlay.classList.remove('is-visible');
      }
    });
  }
  
  // Smooth scroll for collection hero CTA
  function initCollectionCTA() {
    var ctaBtn = document.querySelector('.collection-hero__cta');
    if (!ctaBtn) return;
    
    ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = this.getAttribute('href');
      var target = document.querySelector(targetId);
      if (!target) return;
      
      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  }
  
  // Animate cart items when page first loads
  function animateCartItemsOnLoad() {
    var container = document.getElementById('cart-items-container');
    if (!container) return;
    
    var items = container.querySelectorAll('.cart-item');
    if (items.length === 0) return;
    
    // Add loading state and animate in
    items.forEach(function(item, index) {
      item.classList.add('is-loading');
      setTimeout(function() {
        item.classList.remove('is-loading');
        item.classList.add('animate-in');
      }, 100 + (index * 80));
    });
  }
  
  /* ==================
     WHATSAPP FLOAT POPUP
     ================== */
  function initWhatsAppPopup() {
    var wrapper = document.querySelector('[data-whatsapp-float]');
    if (!wrapper) return;
    var btn = wrapper.querySelector('.whatsapp-float');
    var popup = wrapper.querySelector('.whatsapp-popup');
    var closeBtn = wrapper.querySelector('.whatsapp-popup__close');
    var options = wrapper.querySelectorAll('.whatsapp-popup__option');
    var WA = window.YomikoeWhatsAppPopup || {};
    var isOpen = false;

    function togglePopup(open) {
      isOpen = typeof open === 'boolean' ? open : !isOpen;
      popup.classList.toggle('is-open', isOpen);
      popup.setAttribute('aria-hidden', !isOpen);
      btn.setAttribute('aria-expanded', isOpen);
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      togglePopup();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() { togglePopup(false); });
    }

    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) togglePopup(false);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) togglePopup(false);
    });

    function buildContextLine() {
      if (WA.templateName === 'product' && WA.productTitle) {
        return WA.productTitle + ' - ' + WA.productUrl;
      }
      if (WA.templateName === 'collection' && WA.collectionTitle) {
        return WA.collectionTitle + ' - ' + WA.collectionUrl;
      }
      return '';
    }

    function replaceTemplateVars(msg) {
      var ctx = buildContextLine();
      msg = msg.replace(/\{\{product\}\}/g, WA.productTitle || '');
      msg = msg.replace(/\{\{collection\}\}/g, WA.collectionTitle || '');
      msg = msg.replace(/\{\{url\}\}/g, WA.productUrl || WA.collectionUrl || '');
      return msg;
    }

    options.forEach(function(opt) {
      opt.addEventListener('click', function() {
        var actionType = opt.dataset.actionType;
        var phone = (opt.dataset.phone || WA.phone || '').replace(/\D/g, '');
        var customUrl = opt.dataset.customUrl;
        var message = opt.dataset.whatsappMessage || '';
        var includeContext = opt.dataset.includeContext === 'true';
        var optionLabel = opt.querySelector('.whatsapp-popup__option-text');

        if (actionType === 'url' && customUrl) {
          pushDataLayer('whatsapp_contact', {
            contact_method: 'custom_url',
            option_label: optionLabel ? optionLabel.textContent : '',
            page_type: WA.templateName || ''
          });
          window.open(customUrl, '_blank');
        } else {
          message = replaceTemplateVars(message);
          if (includeContext) {
            var ctx = buildContextLine();
            if (ctx) message += '\n' + ctx;
          }
          fireWhatsAppContactAnalytics(
            optionLabel ? optionLabel.textContent : '',
            WA.templateName,
            { productTitle: WA.productTitle, productId: WA.productId, productPrice: WA.productPrice, productCollection: WA.productCollection, collectionTitle: WA.collectionTitle, collectionId: WA.collectionId }
          );
          var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
          window.open(url, '_blank');
        }
        togglePopup(false);
      });
    });
  }

  // Initialize product page image loading animation
  function initProductImageLoading() {
    var mainImg = document.getElementById('product-main-image');
    var galleryMain = document.getElementById('product-gallery-main');
    if (!mainImg || !galleryMain) return;
    
    // Handle main image load
    if (mainImg.complete && mainImg.naturalWidth > 0) {
      // Image already loaded (cached)
      mainImg.classList.remove('is-loading');
      mainImg.classList.add('is-loaded');
      galleryMain.classList.add('is-loaded');
    } else {
      mainImg.onload = function() {
        mainImg.classList.remove('is-loading');
        mainImg.classList.add('is-loaded');
        galleryMain.classList.add('is-loaded');
      };
    }
  }
})();
